import React, { useState, useEffect, useRef } from "react";
import { Toaster, toast } from "react-hot-toast";
import { showToast } from "../../Helpers/showToast";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { API_URL } from "../../env";
import { POST } from '../../Services/AxiosService';
import { CustomStringify } from "../../Helpers/CustomStringify";
import { DateToShow } from "../../Helpers/DateToShow";
import { DateToShowSplit } from "../../Helpers/DateToShowSplit";
import TypeCase from "../../Helpers/TypeCase";
import { useDispatch, useSelector } from "react-redux";
import { fetchDataPK } from "../../Redux/TransactionsData/PackingChallanDataSlice";
// ------------------------------------------------
// https://piktochart.com/tips/flowchart-examples
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import { numberToWords } from "amount-to-words";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import dayjs from "dayjs";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Chip from "@mui/material/Chip";
import Slide from "@mui/material/Slide";
import Pagination from "@mui/material/Pagination";
import Typography from "@mui/material/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { ArrowDropDownIcon } from "@mui/x-date-pickers/icons";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { enGB } from "date-fns/locale";
import Popover from "@mui/material/Popover";

import noData from "../../Images/nodata.png";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useTheme } from "@mui/system";
import { useMediaQuery } from "@mui/material";
import DeleteDialog from "../../Components/Dialog/DeleteDialog";
import PasswordDialog from "../../Components/Dialog/PasswordDialog";
import { format, toDate } from "date-fns";
import RowPages from "../../Components/RowPages/RowPages";
import { PrintReport } from "../../Components/Print/PrintReport";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const CustomizedTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#e6e7eb',
        color: '#2c2d2e',
        maxWidth: 500,
        border: "1px solid #3e3f40",
        marginRight: "30px"
    },
}));

const DataTableWithPagination = ({
    // data,
    // status,
    // statusS,
    // fetchData,
    data,
    result,
    status,
    statusS,
    fetchData,
}) => {
    const [shouldReRender, setShouldReRender] = useState(false);
    const { cmpdetail } = useSelector((state) => state.CompanyDetail);
    const UserDetail = useSelector((state) => state.UserDetail);
    const Theme = useSelector((state) => state.Theme);
    const PermitData = useSelector((state) => state.PermitData);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const Message = location.state;

    const [Loader, setLoader] = useState(false);
    const [deleteId, setDeleteId] = useState();

    const [PackingChallanData, setPackingChallanData] = useState([]);
    const [HsnDetailsArr, setHsnDetailsArr] = useState([]);
    const [HsnTotalDetails, setHsnTotalDetails] = useState([]);

    const [itemDataArray, setitemDataArray] = useState([]);

    const [mainTotalDiscount, setMainTotalDiscount] = useState();
    const [mainTotalItemCgst, setMainTotalItemCgst] = useState();
    const [mainTotalItemSgst, setMainTotalItemSgst] = useState();
    const [mainTotalItemIgst, setMainTotalItemIgst] = useState();

    const StyledTypography = styled(Typography)(({ theme }) => ({
        "&": {
            background: Theme.primaryThemeColor,
            color: "#fff",
            borderRadius: "25px",
            padding: " 0 5px 0 5px",
            marginTop: "2px",
            border: "2px solid white",
            fontWeight: 600,
            "@media (max-width: 768px)": {
                fontSize: "10px",
            },
        },
    }));

    // const [page, setPage] = useState(1);
    // const [rowsPerPage, setRowsPerPage] = useState(30);

    // const [searchQuery, setSearchQuery] = useState("");
    // const totalPages = Math.ceil(data?.length / rowsPerPage);
    // const startIndex = (page - 1) * rowsPerPage;
    // const endIndex = startIndex + rowsPerPage;

    // const [FilterWithDate, setFilterWithDate] = useState(false);
    // const [FromDate, setFromDate] = useState("");
    // const [ToDate, setToDate] = useState("");

    // const filteredData = data?.filter((row) => {
    //     return (
    //         row.purchase_no?.toLowerCase().includes(searchQuery?.toLowerCase()) ||
    //         row.supplier_name?.toLowerCase().includes(searchQuery?.toLowerCase())
    //     );
    // })?.filter((item) => {
    //     return (FromDate && !ToDate) ? new Date(DateToShowSplit(item?.createdAt)) >= new Date(FromDate) : (!FromDate && ToDate) ? new Date(DateToShowSplit(item?.createdAt)) <= new Date(ToDate) : (FromDate && ToDate) ? new Date(DateToShowSplit(item?.createdAt)) >= new Date(FromDate) && new Date(DateToShowSplit(item?.createdAt)) <= new Date(ToDate) : true
    // });

    // const paginatedData = filteredData?.slice(startIndex, endIndex);
    // const totalRecords = paginatedData?.length;

    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(30);

    const [searchQuery, setSearchQuery] = useState("");

    const [FilterWithDate, setFilterWithDate] = useState(false);
    const [FromDate, setFromDate] = useState("");
    const [ToDate, setToDate] = useState("");

    // Backend pagination data
    const paginatedData = data || [];

    const totalRecords = result?.totalRecords || 0;
    const totalPages = result?.totalPages || 0;




    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const filterDates = Boolean(anchorEl);


    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setPage(1);
    };


    useEffect(() => {
        const timer = setTimeout(() => {
            dispatch(
                fetchData({
                    cmpdetail,
                    UserDetail,
                    page: 1,
                    limit: rowsPerPage,
                    search: searchQuery,
                    fromDate: FilterWithDate ? FromDate : "",
                    toDate: FilterWithDate ? ToDate : "",
                })
            );
        }, 500);

        return () => clearTimeout(timer);
    }, [searchQuery]);


    const handleFromDate = (value) => {
        setFromDate(value);
        // dispatch(fetchData({}));
        setPage(1)
    };

    const handleToDate = (value) => {
        setToDate(value);
        // dispatch(fetchData({}));
        setPage(1)
    };

    useEffect(() => {
        if (!FilterWithDate) return;

        dispatch(
            fetchData({
                cmpdetail,
                UserDetail,
                page: 1,
                limit: rowsPerPage,
                search: searchQuery,
                fromDate: FromDate,
                toDate: ToDate,
            })
        );
    }, [FromDate, ToDate]);

    // const handlePageChange = (event, value) => {
    //     setPage(value);
    // };

    const handlePageChange = (event, value) => {
        setPage(value);

        dispatch(
            fetchData({
                cmpdetail,
                UserDetail,
                page: value,
                limit: rowsPerPage,
                search: searchQuery,
                fromDate: FilterWithDate ? FromDate : "",
                toDate: FilterWithDate ? ToDate : "",
            })
        );
    };

    // const handleChangeRowsPerPage = (value) => {
    //     setRowsPerPage(value);
    // };

    const handleChangeRowsPerPage = (value) => {
        setRowsPerPage(value);
        setPage(1);

        dispatch(
            fetchData({
                cmpdetail,
                UserDetail,
                page: 1,
                limit: value,
                search: searchQuery,
                fromDate: FilterWithDate ? FromDate : "",
                toDate: FilterWithDate ? ToDate : "",
            })
        );
    };

    const hexToRGBFade = (hex, fade) => {
        hex = hex.replace("#", "");
        // Parse the red, green, and blue components from the hex string
        let r = parseInt(hex.substring(0, 2), 16);
        let g = parseInt(hex.substring(2, 4), 16);
        let b = parseInt(hex.substring(4, 6), 16);
        // Return the RGB value
        return `rgb(${r}, ${g}, ${b}, ${fade})`;
    };

    const handleDownloadCSV = () => {
        const csvData =
            "Challan No.,Date,Bill No.,Bill Date,Party Name,Transport,Qty,Taxable Amt,Total Amount\n" +
            data?.map((row) => {
                return `"${row.purchase_no}","${DateToShow(row.createdAt)}","${row.bill_no}","${DateToShow(row.bill_date)}","${cmpdetail?.company_name}","${row?.transport}","${row.total_quantity}","${row.totalAmount}","${row.net_amount}"`;
            }).join("\n");

        const blob = new Blob([csvData], { type: "text/csv" });

        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Packing_Challan.csv";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    const tooltipRef = useRef(null);
    const [openTooltip, setOpenTooltip] = useState(data?.map(() => false) || []);

    const handleTooltipClose = () => {
        setOpenTooltip((pre) => pre?.map(() => false));
    };

    const handleTooltipOpen = (index) => {
        setOpenTooltip((pre) => pre?.map((item, ind) => index == ind ? !item : item));

        setShouldReRender(true);
        setTimeout(() => setShouldReRender(false), 1);
    };

    useEffect(() => {
        setOpenTooltip(data?.map(() => false) || []);
    }, [data]);

    useEffect(() => {
        const handleClickAway = (event) => {
            if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
                setOpenTooltip((pre) => pre?.map(() => false));
            }
        };

        document.addEventListener('mousedown', handleClickAway);
        return () => {
            document.removeEventListener('mousedown', handleClickAway);
        };
    }, []);

    const [modalOpenDelete, setModalOpenDelete] = useState(false);
    const [modalOpenPassword, setModalOpenPassword] = useState(false);

    const handleModalOpenDelete = () => {
        setModalOpenDelete(true);
    };
    const handleModalCloseDelete = () => {
        setModalOpenDelete(false);
    };

    const handleModalOpenPassword = () => {
        setModalOpenPassword(true);
    };
    const handleModalClosePassword = () => {
        setModalOpenPassword(false);
    };

    const openPrint = (id) => {
        getPackingChallanById(id);
    };

    // const DeManipulateData = (array) => {
    //     let newAryy = [];
    //     let rows = [];
    //     array?.map((item) => {
    //         if (rows.includes(item?.SLBDtl_Flag_ID) == false) {
    //             rows.push(item?.SLBDtl_Flag_ID);
    //         }
    //     });

    //     rows?.sort()?.map((item) => {
    //         let newObj = {};
    //         let ClrSize = [];
    //         let SbIdArr = [];
    //         let sameFlagArr = array?.filter((elem) => {
    //             return item == elem?.SLBDtl_Flag_ID;
    //         });
    //         let uniqColors = [];
    //         sameFlagArr?.map((elem) => {
    //             if (uniqColors.includes(elem?.SLBDtl_ColourID) == false) {
    //                 uniqColors.push(elem?.SLBDtl_ColourID);
    //             }
    //             SbIdArr.push(elem?.SLBDtl_Id);
    //             newObj = { ...elem, SLBDtl_Id: SbIdArr };
    //         });

    //         if (sameFlagArr[0]?.SLBDtl_PerSizeQty) {
    //             uniqColors.sort()?.map((ele) => {
    //                 let obj = { SLBDtl_ColourID: ele };
    //                 let sizes = [];
    //                 sameFlagArr
    //                     ?.filter((el) => {
    //                         return ele == el?.SLBDtl_ColourID;
    //                     })
    //                     ?.map((e) => {
    //                         sizes.push({
    //                             SLBDtl_SizeID: e?.SLBDtl_SizeID,
    //                             SLBDtl_PerSizeQty: e?.SLBDtl_PerSizeQty,
    //                         });
    //                     });
    //                 obj.sizes = sizes;
    //                 ClrSize.push(obj);
    //             });
    //             newObj.ClrSize = ClrSize;
    //             delete newObj.SLBDtl_ColourID;
    //             delete newObj.SLBDtl_SizeID;
    //             delete newObj.SLBDtl_PerSizeQty;
    //             delete newObj.$id;
    //             newAryy.push(newObj);
    //         } else if (sameFlagArr[0]?.SLBDtl_PerPiece_Mtrs) {
    //             sameFlagArr?.map((e) => {
    //                 ClrSize.push({
    //                     SLBDtl_ColourID: e?.SLBDtl_ColourID,
    //                     SLBDtl_PerPiece_Mtrs: e?.SLBDtl_PerPiece_Mtrs,
    //                 });
    //             });
    //             newObj.ClrSize = ClrSize;
    //             delete newObj.SLBDtl_ColourID;
    //             delete newObj.SLBDtl_PerPiece_Mtrs;
    //             delete newObj.$id;
    //             newAryy.push(newObj);
    //         } else {
    //             delete newObj.$id;
    //             newAryy.push(newObj);
    //         }
    //     });
    //     return newAryy;
    // };

    const setMainTotalData = (newItemDataArr) => {
        var mainTotQty = 0;
        var mainTotDis = 0;
        var mainTotTaxAmt = 0;
        var mainTotItemCgst = 0;
        var mainTotItemSgst = 0;
        var mainTotItemIgst = 0;
        var mainTotAmt = 0;

        newItemDataArr?.map((item) => {
            mainTotQty = mainTotQty + Number(item?.qty);
            mainTotDis = mainTotDis + Number(item?.discount_amount);
            mainTotTaxAmt = mainTotTaxAmt + Number(item?.amountbft);
            mainTotItemCgst = mainTotItemCgst + Number(item?.cgstamt);
            mainTotItemSgst = mainTotItemSgst + Number(item?.sgstamt);
            mainTotItemIgst = mainTotItemIgst + Number(item?.igstamt);
            mainTotAmt = mainTotAmt + Number(item?.amount);
        });

        setMainTotalDiscount(mainTotDis?.toFixed(2));
        setMainTotalItemCgst(mainTotItemCgst?.toFixed(2));
        setMainTotalItemSgst(mainTotItemSgst?.toFixed(2));
        setMainTotalItemIgst(mainTotItemIgst?.toFixed(2));
    };

    const getPackingChallanById = async (id) => {
        setLoader(true);
        const PackingChallan = paginatedData?.find((item) => item?.id == id);

        setPackingChallanData(PackingChallan);
        let newItemDataArr = PackingChallan?.OrderDesign?.map((item) => {
            return { ...item, amountbft: (Number(item?.qty) * Number(item?.rate)).toFixed(2), cgstamt: ((Number(item?.qty) * Number(item?.rate)) * ((item?.gsttype?.includes("cgst") ? item?.cgst : 0) / 100)).toFixed(2), sgstamt: ((Number(item?.qty) * Number(item?.rate)) * ((item?.gsttype?.includes("sgst") ? item?.sgst : 0) / 100)).toFixed(2), igstamt: ((Number(item?.qty) * Number(item?.rate)) * ((item?.gsttype?.includes("igst") ? item?.igst : 0) / 100)).toFixed(2), amount: ((Number(item?.qty) * Number(item?.rate)) + (Number(item?.qty) * Number(item?.rate)) * (item?.totalgst / 100)).toFixed(2) }
        });
        setitemDataArray(newItemDataArr);
        setMainTotalData(newItemDataArr);

        setLoader(false);
        setTimeout(() => {
            handlePrintReport();
        }, 500);

        setShouldReRender(true);
        setTimeout(() => setShouldReRender(false), 1);
    };

    // const [Led_Whatsaap, setLed_Whatsaap] = useState();
    // const [Led_GSTNo, setLed_GSTNo] = useState();
    // const [Led_Address, setLed_Address] = useState();
    // const [Led_Pincode, setLed_Pincode] = useState();
    // const [Led_City, setLed_City] = useState();
    // const [Led_State, setLed_State] = useState();
    // const [LedState_Code, setLedState_Code] = useState();
    // const [Led_StateID, setLed_StateID] = useState();

    // const GetLedDetail = async (id) => {
    //     var requestData = CustomStringify({
    //         Database: cmpdetail?.Database,
    //         Password: cmpdetail?.Password,
    //         Server: cmpdetail?.Server,
    //         User_ID: cmpdetail?.User_ID,
    //         Port: cmpdetail?.Port,
    //     });

    //     try {
    //         const result = await POST(`/GetLedgerbyID?id=${id}`, requestData);

    //         setLed_Whatsaap(result?.data[0]?.Led_Whatsaap);
    //         setLed_GSTNo(result?.data[0]?.Led_GSTNo);
    //     } catch (error) {
    //         setLoader(false);
    //         showToast(error?.response?.data?.message || error?.message, "error");
    //     }
    // };

    // const GetLedAddress = async (id) => {
    //     setLoader(true);

    //     var requestData = CustomStringify({
    //         Database: cmpdetail?.Database,
    //         Password: cmpdetail?.Password,
    //         Server: cmpdetail?.Server,
    //         User_ID: cmpdetail?.User_ID,
    //         Port: cmpdetail?.Port,
    //     });

    //     try {
    //         const result = await POST(`/GetAddress_By_LedgerID?id=${id}`, requestData);

    //         setLoader(false);
    //         let BillingAddress = result?.data?.filter((item) => item?.LedAdd_AddType == 1);
    //         setLed_Address(BillingAddress?.length > 0 ? BillingAddress[0]?.LedAdd_Address : result?.data[0]?.LedAdd_Address);
    //         setLed_Pincode(BillingAddress?.length > 0 ? BillingAddress[0]?.LedAdd_Pincode : result?.data[0]?.LedAdd_Pincode);
    //         setLed_City(BillingAddress?.length > 0 ? BillingAddress[0]?.city : result?.data[0]?.city);
    //         setLed_State(BillingAddress?.length > 0 ? BillingAddress[0]?.state : result?.data[0]?.state);
    //         setLedState_Code(BillingAddress?.length > 0 ? BillingAddress[0]?.LedState_Code : result?.data[0]?.LedState_Code);
    //         setLed_StateID(BillingAddress?.length > 0 ? BillingAddress[0]?.LedAdd_State : result?.data[0]?.LedAdd_State);

    //         setShouldReRender(true);
    //         setTimeout(() => setShouldReRender(false), 1);
    //     } catch (error) {
    //         setLoader(false);
    //         showToast(error?.response?.data?.message || error?.message, "error");
    //     }
    // };

    // const GetHSNDetails = async (id) => {
    //     var myHeaders = new Headers();
    //     const Token = localStorage.getItem("token");
    //     myHeaders.append("Content-Type", "application/json");
    //     myHeaders.append("Access-Control-Allow-Origin", "*");
    //     myHeaders.append("Authorization", `Bearer ${Token}`);

    //     var raw = CustomStringify({
    //         Database: cmpdetail?.Database,
    //         Password: cmpdetail?.Password,
    //         Server: cmpdetail?.Server,
    //         User_ID: cmpdetail?.User_ID,
    //         Port: cmpdetail?.Port,
    //     });

    //     var requestOptions = {
    //         method: "POST",
    //         headers: myHeaders,
    //         body: raw,
    //         redirect: "follow",
    //     };

    //     fetch(`${API_URL}/Filter_HSNSLB_ByMainId?id=${id}`, requestOptions)
    //         .then((response) => response.json())
    //         .then((result) => {
    //             if (result?.status == true) {
    //                 setHsnDetailsArr(result?.data);

    //                 let HsnTotDetails = {
    //                     Qty: 0,
    //                     // MTRs: 0,
    //                     TaxAmt: 0,
    //                     CgstAmt: 0,
    //                     SgstAmt: 0,
    //                     IgstAmt: 0,
    //                 };
    //                 result?.data?.map((item) => {
    //                     HsnTotDetails.Qty = HsnTotDetails.Qty + Number(item?.Qty);
    //                     // HsnTotDetails.MTRs = HsnTotDetails.MTRs + Number(item?.MTRs);
    //                     HsnTotDetails.TaxAmt =
    //                         HsnTotDetails.TaxAmt + Number(item?.TaxableAmt);
    //                     HsnTotDetails.CgstAmt =
    //                         HsnTotDetails.CgstAmt + Number(item?.CGSTAmt);
    //                     HsnTotDetails.SgstAmt =
    //                         HsnTotDetails.SgstAmt + Number(item?.SGSTAmt);
    //                     HsnTotDetails.IgstAmt =
    //                         HsnTotDetails.IgstAmt + Number(item?.IGSTAmt);
    //                 });

    //                 setHsnTotalDetails(HsnTotDetails);
    //             } else {
    //                 // showToast(result?.message, "error");
    //             }
    //         })
    //         .catch((error) => console.log("error", error));
    // };

    // const MergeData = (ItemArray) => {
    //     const mergedArray = ItemArray.reduce(
    //         (accumulator, current) => {
    //             const existing = accumulator.find(
    //                 (item) =>
    //                     (item.Desg_Code === current.Desg_Code) &&
    //                     (item.pdt_code === current.pdt_code) &&
    //                     (item.SLBDtl_Rate === current.SLBDtl_Rate) &&
    //                     (item.SLBDtl_DiscountPer === current.SLBDtl_DiscountPer)
    //             );

    //             if (existing) {
    //                 existing.SLBDtl_Qty += current.SLBDtl_Qty;
    //                 existing.SLBDtl_DiscountAmt += current.SLBDtl_DiscountAmt;
    //                 existing.SLBDtl_CGSTAmt += current.SLBDtl_CGSTAmt;
    //                 existing.SLBDtl_SGSTAmt += current.SLBDtl_SGSTAmt;
    //                 existing.SLBDtl_IGSTAmt += current.SLBDtl_IGSTAmt;
    //                 existing.SLBDtl_AmountBFT += current.SLBDtl_AmountBFT;
    //                 existing.SLBDtl_Amount += current.SLBDtl_Amount;
    //             } else {
    //                 accumulator.push({ ...current });
    //             }

    //             return accumulator;
    //         },
    //         []
    //     );
    //     return mergedArray;
    // }

    const removeSaleBill = async () => {
        setLoader(true);
        var myHeaders = new Headers();
        myHeaders.append("Access-Control-Allow-Origin", "*");
        myHeaders.append("Content-Type", "application/json");

        let data = paginatedData?.find((item) => item?.id == deleteId);

        var rawData = CustomStringify({
            et_ledger_id: data?.et_ledger_id,
            supplierId: data?.supplierId,
            party: data?.party,
            supplier_name: data?.supplier_name,
            address: data?.address,
            mobile_no: data?.mobile_no,
            GSTIN: data?.GSTIN,
            PINCode: data?.PINCode,
            et_state_id: data?.et_state_id,
            state: data?.state,
            et_city_id: data?.et_city_id,
            city: data?.city,
            et_broker_id: data?.et_broker_id,
            broker: data?.broker,
            bill_no: data?.bill_no,
            bill_date: data?.bill_date,
            et_transport_id: data?.et_transport_id,
            transport: data?.transport,
            total_quantity: data?.total_quantity,
            totalAmount: data?.totalAmount,
            gst_amount: data?.gst_amount,
            net_amount: data?.net_amount,
            OrderDesign: data?.OrderDesign,
            orderId: data?.orderId,
            orderdate: data?.orderdate,
            order_no: data?.order_no,
            is_cancel: true,
        });

        var requestOptions = {
            method: "PATCH",
            headers: myHeaders,
            body: rawData,
            redirect: "follow",
        };

        fetch(`${API_URL}/purchase/${cmpdetail?.key}/${deleteId}`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                if (result?.success === true) {
                    handleModalCloseDelete();
                    setLoader(false);
                    showToast("Deleted Successfully", "success");
                    dispatch(fetchData({ cmpdetail, UserDetail }));
                } else {
                    setLoader(false);
                    showToast(result?.message, "error");
                }
            })
            .catch((error) => {
                setLoader(false);
                showToast("API Error", "error");
                console.log(error);
            });
    };

    const deletePackingChallan = (row) => {
        handleModalOpenDelete();
        setDeleteId(row?.id);
    };

    useEffect(() => {
        const keyEnter = (event) => {
            if (event.altKey) {
                event.preventDefault();
                switch (event.key) {
                    case "n":
                        navigate("AddPackingChallan");
                        break;
                    default:
                        break;
                }
            }
        };

        document.addEventListener("keydown", keyEnter);

        return () => {
            document.removeEventListener("keydown", keyEnter);
        };
    });

    useEffect(() => {
        if (Message) {
            showToast(Message, "success");
            navigate(location.pathname, { replace: true });
        }
    }, []);


    const printRef = useRef();
    const PrintReportRef = useRef(null);

    const handlePrintReport = () => {
        if (PrintReportRef.current) {
            PrintReportRef.current.printReport();
        }
    };

    const Muitheme = useTheme();
    const isMobile = useMediaQuery(Muitheme.breakpoints.down("sm"));

    const theme = createTheme({
        palette: {
            primary: {
                main: Theme.primaryThemeColor,
            },
        },
        typography: {
            fontFamily: "Poppins",
            h4: {
                fontWeight: "500",
                fontSize: "20px",
                "@media (max-width: 768px)": {
                    fontSize: "16px",
                },
            },
            subtitle2: {
                "@media (max-width: 768px)": {
                    display: "none"
                },
            }
        },
        components: {
            MuiInputBase: {
                styleOverrides: {
                    root: {
                        fontSize: "13px",
                        height: "28px",
                        width: "25vw",
                        minWidth: "100px",
                        background: "#fff",
                    },
                },
            },
            MuiInputLabel: {
                styleOverrides: {
                    root: {
                        fontSize: "14px",
                        marginTop: "-12px",
                    },
                },
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        color: "#fff",
                        fontSize: "13px",
                        maxWidth: "260px",
                        height: "28px",
                        padding: "12px 8px 12px 8px",
                        fontWeight: 500,
                        "@media (max-width: 768px)": {
                            fontSize: "11px",
                            padding: "10px 5px 10px 5px",
                        },
                    },
                },
            },
            MuiFormControlLabel: {
                styleOverrides: {
                    label: {
                        fontSize: "16px",
                        "@media (max-width: 768px)": {
                            fontSize: "13px",
                        },
                    },
                },
            },
            MuiTableCell: {
                styleOverrides: {
                    root: {
                        borderBottom: "1px solid #9a9da1",
                    },
                    head: {
                        "&::after": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: hexToRGBFade(Theme.primaryThemeColor, 0.4),
                            zIndex: -1,
                        },
                        whiteSpace: "nowrap",
                        width: "auto",
                        "@media (max-width: 768px)": {
                            fontSize: "13px",
                            padding: "2px 16px"
                        },
                    },
                    body: {
                        whiteSpace: "nowrap",
                        width: "auto",
                        "@media (max-width: 768px)": {
                            fontSize: "13px",
                            padding: "2px 16px"
                        },
                    },
                },
            },
        },
    });

    const form = createTheme({
        palette: {
            primary: {
                main: Theme.primaryThemeColor,
            },
        },
        typography: {
            fontFamily: "Poppins",
        },
        components: {
            MuiInputBase: {
                styleOverrides: {
                    root: {
                        fontSize: "15px",
                        height: "28px",
                        width: "150px",
                        background: "#fff",
                    },
                },
            },
            MuiInputLabel: {
                styleOverrides: {
                    root: {
                        fontSize: "14px",
                        marginTop: "-10px",
                    },
                },
            },
        },
    });

    return (
        <>
            <PrintReport TxnName={"PackingChallan"} printRef={printRef} Led_Whatsaap={""} Led_Email={""} SONO={PackingChallanData?.purchase_no} EmailBSMSDetails={""} handleModalCloseEmail={null} Brok_Whatsapp={""} handleModalCloseBSMS={null} printRefFN={""} ref={PrintReportRef} />

            <div className="print-box" ref={printRef} style={{ display: "none" }}>
                <div className="container-fluid mt-3 print-only">
                    <h2
                        style={{
                            fontFamily: "Poppins",
                            fontSize: 22,
                            color: "#000",
                            fontWeight: 600,
                            textAlign: "center"
                        }}
                    >
                        {UserDetail?.result?.user?.company_name}
                    </h2>
                    <div className="d-flex" style={{ width: "100%", alignItems: "center" }}>
                        <div style={{ width: "33%", textAlign: "start" }}>
                            {/* <img src={cmpdetail?.logoImg} alt="logo" style={{ width: "90%" }} /> */}
                        </div>
                        <div style={{ width: "33%", textAlign: "center" }}>
                            <h6
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: 14,
                                    color: "#000",
                                    fontWeight: 500,
                                }}
                            >
                                {UserDetail?.result?.user?.address ? UserDetail?.result?.user?.address + "," : null}{" "}
                                {UserDetail?.result?.user?.state} {UserDetail?.result?.user?.city} ({UserDetail?.result?.user?.pin_code})
                            </h6>
                            <h6
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: 14,
                                    color: "#000",
                                    fontWeight: 500,
                                }}
                            >
                                {UserDetail?.result?.user?.mobile_no}{" "}
                                {/* {UserDetail?.result?.user?.Contactno ? ", " + UserDetail?.result?.user?.Contactno : ""} */}
                            </h6>
                            <h6
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: 14,
                                    color: "#000",
                                    fontWeight: 500,
                                }}
                            >
                                {UserDetail?.result?.user?.Email}
                            </h6>
                            <div
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: 13,
                                    color: "#000",
                                    fontWeight: 600,
                                }}
                            >
                                GSTNo. {UserDetail?.result?.user?.GSTIN}
                            </div>
                            <h6
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: 15,
                                    color: "#000",
                                    fontWeight: 600,
                                    margin: "5px 0 5px 0",
                                }}
                            >
                                TAX CHALLAN
                            </h6>
                        </div>
                        <div style={{ width: "33%", textAlign: "end" }}>
                            &nbsp;
                            {/* <img src={cmpdetail?.logoImg} alt="logo" style={{ width: "90%" }} /> */}
                        </div>
                    </div>

                    <div className="row mt-2 g-0" style={{ border: "1px solid #000" }}>
                        <div className="col-6" style={{ borderRight: "1px solid #000" }}>
                            <div className="box rounded-0 p-1 bg-transparent">
                                <div className="row">
                                    <div
                                        className="col-3"
                                        style={{
                                            fontFamily: "Poppins",
                                            fontSize: 12,
                                            color: "#000",
                                            fontWeight: 500,
                                            paddingRight: 0
                                        }}
                                    >
                                        Challan No.
                                    </div>
                                    <div
                                        className="text-start col-5"
                                        style={{
                                            fontFamily: "Poppins",
                                            fontSize: 12,
                                            color: "#000",
                                            fontWeight: 600,
                                            paddingLeft: 0,
                                            paddingRight: 0
                                        }}
                                    >
                                        :&nbsp; {PackingChallanData?.purchase_no}
                                    </div>
                                    <div
                                        className="col-1"
                                        style={{
                                            fontFamily: "Poppins",
                                            fontSize: 12,
                                            color: "#000",
                                            fontWeight: 500,
                                            paddingLeft: 0,
                                            paddingRight: 0
                                        }}
                                    >
                                        Date
                                    </div>
                                    <div
                                        className="text-start col-3"
                                        style={{
                                            fontFamily: "Poppins",
                                            fontSize: 11.5,
                                            color: "#000",
                                            fontWeight: 600,
                                            paddingLeft: 0,
                                            paddingRight: 0
                                        }}
                                    >
                                        :&nbsp;{" "}
                                        {DateToShow(PackingChallanData?.createdAt)}
                                    </div>
                                    <div
                                        className="col-3"
                                        style={{
                                            fontFamily: "Poppins",
                                            fontSize: 12,
                                            color: "#000",
                                            fontWeight: 500,
                                            paddingRight: 0
                                        }}
                                    >
                                        Bill No.
                                    </div>
                                    <div
                                        className="text-start col-4"
                                        style={{
                                            fontFamily: "Poppins",
                                            fontSize: 12,
                                            color: "#000",
                                            fontWeight: 600,
                                            paddingLeft: 0,
                                            paddingRight: 0
                                        }}
                                    >
                                        :&nbsp; {PackingChallanData?.bill_no}
                                    </div>
                                    <div
                                        className="col-2"
                                        style={{
                                            fontFamily: "Poppins",
                                            fontSize: 12,
                                            color: "#000",
                                            fontWeight: 500,
                                            paddingLeft: 0,
                                            paddingRight: 0
                                        }}
                                    >
                                        Bill Date
                                    </div>
                                    <div
                                        className="text-start col-3"
                                        style={{
                                            fontFamily: "Poppins",
                                            fontSize: 11.5,
                                            color: "#000",
                                            fontWeight: 600,
                                            paddingLeft: 0,
                                            paddingRight: 0
                                        }}
                                    >
                                        :&nbsp;{" "}
                                        {DateToShow(PackingChallanData?.bill_date)}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="box rounded-0 p-1 border-0 bg-transparent">
                                <div className="row">
                                    <div
                                        className="col-3"
                                        style={{
                                            fontFamily: "Poppins",
                                            fontSize: 12,
                                            color: "#000",
                                            fontWeight: 500,
                                            paddingRight: 0
                                        }}
                                    >
                                        Agent
                                    </div>
                                    <div
                                        className="text-start col-9"
                                        style={{
                                            fontFamily: "Poppins",
                                            fontSize: 12,
                                            color: "#000",
                                            fontWeight: 600,
                                            paddingLeft: 0,
                                            paddingRight: 0
                                        }}
                                    >
                                        :&nbsp; {PackingChallanData?.broker}
                                    </div>
                                    <div
                                        className="col-3"
                                        style={{
                                            fontFamily: "Poppins",
                                            fontSize: 12,
                                            color: "#000",
                                            fontWeight: 500,
                                            paddingRight: 0
                                        }}
                                    >
                                        Transport
                                    </div>
                                    <div
                                        className="text-start col-9"
                                        style={{
                                            fontFamily: "Poppins",
                                            fontSize: 12,
                                            color: "#000",
                                            fontWeight: 600,
                                            paddingLeft: 0,
                                            paddingRight: 0
                                        }}
                                    >
                                        :&nbsp; {PackingChallanData?.transport}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row g-0">
                        <div
                            className="col-12"
                            style={{
                                borderLeft: "1px solid #000",
                                borderRight: "1px solid #000",
                                textAlign: "center",
                            }}
                        >
                            <div className="box rounded-0 p-1 bg-transparent">
                                <div
                                    style={{
                                        fontFamily: "Poppins",
                                        fontSize: 12,
                                        color: "#000",
                                        fontWeight: 600,
                                    }}
                                >
                                    Details of Receiver | Billed To
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="row g-0"
                        style={{
                            border: "1px solid #000",
                            borderBottom: "0px solid #000",
                        }}
                    >
                        <div className="col-12">
                            <div className="box rounded-0 p-1 bg-transparent border-0">
                                <div className="row">
                                    <div
                                        className="col-2"
                                        style={{
                                            fontFamily: "Poppins",
                                            fontSize: 12,
                                            color: "#000",
                                            fontWeight: 500,
                                            paddingRight: 0
                                        }}
                                    >
                                        Name
                                    </div>
                                    <div
                                        className="text-start col-10"
                                        style={{
                                            fontFamily: "Poppins",
                                            fontSize: 14,
                                            color: "#000",
                                            fontWeight: 600,
                                            paddingLeft: 0,
                                            paddingRight: 0
                                        }}
                                    >
                                        :&nbsp;{PackingChallanData?.is_cancel ? "" : cmpdetail?.company_name}
                                    </div>
                                </div>
                                <div className="row">
                                    <div
                                        className="col-2"
                                        style={{
                                            fontFamily: "Poppins",
                                            fontSize: 12,
                                            color: "#000",
                                            fontWeight: 500,
                                            paddingRight: 0
                                        }}
                                    >
                                        Address
                                    </div>
                                    <div
                                        className="text-start col-10"
                                        style={{
                                            fontFamily: "Poppins",
                                            fontSize: 12,
                                            color: "#000",
                                            fontWeight: 600,
                                            paddingLeft: 0,
                                            paddingRight: 0
                                        }}
                                    >
                                        :&nbsp; {PackingChallanData?.is_cancel ? "" : `${cmpdetail?.Address ? cmpdetail?.Address + "," : null} ${cmpdetail?.city} ${cmpdetail?.pin_code ? ", " + cmpdetail?.pin_code : null}`}
                                    </div>
                                    <div
                                        className="col-2"
                                        style={{
                                            fontFamily: "Poppins",
                                            fontSize: 12,
                                            color: "#000",
                                            fontWeight: 500,
                                            paddingRight: 0
                                        }}
                                    >
                                        Mobile No.
                                    </div>
                                    <div
                                        className="text-start col-10"
                                        style={{
                                            fontFamily: "Poppins",
                                            fontSize: 12,
                                            color: "#000",
                                            fontWeight: 600,
                                            paddingLeft: 0,
                                            paddingRight: 0
                                        }}
                                    >
                                        :&nbsp;{PackingChallanData?.is_cancel ? "" : cmpdetail?.mobile_no}
                                    </div>
                                    <div
                                        className="col-2"
                                        style={{
                                            fontFamily: "Poppins",
                                            fontSize: 12,
                                            color: "#000",
                                            fontWeight: 500,
                                            paddingRight: 0
                                        }}
                                    >
                                        GST No.
                                    </div>
                                    <div
                                        className="text-start col-10"
                                        style={{
                                            fontFamily: "Poppins",
                                            fontSize: 12,
                                            color: "#000",
                                            fontWeight: 600,
                                            paddingLeft: 0,
                                            paddingRight: 0
                                        }}
                                    >
                                        :&nbsp;{PackingChallanData?.is_cancel ? "" : cmpdetail?.gst_no}
                                    </div>
                                    <div
                                        className="col-2"
                                        style={{
                                            fontFamily: "Poppins",
                                            fontSize: 12,
                                            color: "#000",
                                            fontWeight: 500,
                                            paddingRight: 0
                                        }}
                                    >
                                        State
                                    </div>
                                    <div
                                        className="text-start col-10"
                                        style={{
                                            fontFamily: "Poppins",
                                            fontSize: 12,
                                            color: "#000",
                                            fontWeight: 600,
                                            paddingLeft: 0,
                                            paddingRight: 0
                                        }}
                                    >
                                        :&nbsp;{" "}
                                        {PackingChallanData?.is_cancel ? "" : cmpdetail?.state}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bill-body">
                        <table className="bill-body-table">
                            <thead>
                                <tr className="table-head">
                                    <th className="table-head-text text-end">SN.</th>
                                    <th className="table-head-text">Description</th>
                                    <th className="table-head-text text-center">HSN</th>
                                    <th className="table-head-text text-end">QTY</th>
                                    <th className="table-head-text text-end">RATE</th>
                                    {mainTotalDiscount > 0 ? (
                                        <>
                                            <th colspan="2" className="table-head-text text-end">
                                                DISCOUNT
                                            </th>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    {mainTotalItemCgst > 0 ? (
                                        <>
                                            <th colspan="2" className="table-head-text text-center">
                                                CGST
                                            </th>
                                            <th colspan="2" className="table-head-text text-center">
                                                SGST
                                            </th>
                                        </>
                                    ) : (
                                        <th colspan="2" className="table-head-text text-center">
                                            IGST
                                        </th>
                                    )}
                                    <th className="table-head-text text-end">AMT BFT</th>
                                </tr>
                            </thead>
                            <tbody>
                                {PackingChallanData?.OrderDesign?.map((item, index) => (
                                    <tr className="table-body" key={index}>
                                        <td
                                            className="table-body-text text-end"
                                            style={{ width: "30px" }}
                                        >
                                            {index + 1}
                                        </td>
                                        <td className="table-body-text">
                                            {item?.supply_design} - {item?.product} ({item?.design_no})
                                        </td>
                                        <td
                                            className="table-body-text text-center"
                                            style={{ width: "60px" }}
                                        >
                                            {item?.hsn_code}
                                        </td>
                                        <td
                                            className="table-body-text text-end"
                                            style={{ width: "60px" }}
                                        >
                                            {item?.qty ? item?.qty : null}
                                        </td>
                                        <td
                                            className="table-body-text text-end"
                                            style={{ width: "60px" }}
                                        >
                                            {item?.rate ? item?.rate : null}
                                        </td>
                                        {mainTotalDiscount > 0 ? (
                                            <>
                                                <td
                                                    className="table-body-text text-end"
                                                    style={{ width: "50px" }}
                                                >
                                                    <b>
                                                        {item?.discount_per
                                                            ? item?.discount_per + "%"
                                                            : ""}
                                                    </b>
                                                </td>
                                                <td
                                                    className="table-body-text text-end"
                                                    style={{ width: "50px" }}
                                                >
                                                    {item?.discount_amount
                                                        ? item?.discount_amount
                                                        : ""}
                                                </td>
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                        {mainTotalItemCgst > 0 ? (
                                            <>
                                                <td
                                                    className="table-body-text text-end"
                                                    style={{ width: "50px" }}
                                                >
                                                    <b>
                                                        {item?.cgst
                                                            ? item?.cgst + "%"
                                                            : ""}
                                                    </b>
                                                </td>
                                                <td
                                                    className="table-body-text text-end"
                                                    style={{ width: "50px" }}
                                                >

                                                    {((Number(item?.qty) * (Number(item?.rate) - ((Number(item?.discount_per) / 100) * Number(item?.rate)))) * ((item?.gsttype?.includes("cgst") ? item?.cgst : 0) / 100)).toFixed(2)}
                                                </td>
                                                <td
                                                    className="table-body-text text-end"
                                                    style={{ width: "50px" }}
                                                >
                                                    <b>
                                                        {item?.sgst
                                                            ? item?.sgst + "%"
                                                            : ""}
                                                    </b>
                                                </td>
                                                <td
                                                    className="table-body-text text-end"
                                                    style={{ width: "50px" }}
                                                >
                                                    {((Number(item?.qty) * (Number(item?.rate) - ((Number(item?.discount_per) / 100) * Number(item?.rate)))) * ((item?.gsttype?.includes("sgst") ? item?.sgst : 0) / 100)).toFixed(2)}
                                                </td>
                                            </>
                                        ) : (
                                            <>
                                                <td
                                                    className="table-body-text text-end"
                                                    style={{ width: "50px" }}
                                                >
                                                    <b>
                                                        {item?.igst
                                                            ? item?.igst + "%"
                                                            : ""}
                                                    </b>
                                                </td>
                                                <td
                                                    className="table-body-text text-end"
                                                    style={{ width: "50px" }}
                                                >
                                                    {((Number(item?.qty) * (Number(item?.rate) - ((Number(item?.discount_per) / 100) * Number(item?.rate)))) * ((item?.gsttype?.includes("igst") ? item?.igst : 0) / 100)).toFixed(2)}
                                                </td>
                                            </>
                                        )}
                                        <td
                                            className="table-body-text text-end"
                                            style={{ width: "80px" }}
                                        >
                                            {(Number(item?.qty) * (Number(item?.rate) - ((Number(item?.discount_per) / 100) * Number(item?.rate)))).toFixed(2)}
                                        </td>
                                    </tr>
                                ))}
                                <tr
                                    className="table-body"
                                    style={{
                                        height: `calc(${"20vh"} - (${"35px"}*${PackingChallanData?.OrderDesign?.length
                                            }))`,
                                    }}
                                >
                                    <td className="table-empty-text"></td>
                                    <td className="table-empty-text"></td>
                                    <td className="table-empty-text"></td>
                                    <td className="table-empty-text"></td>
                                    <td className="table-empty-text"></td>
                                    {mainTotalDiscount > 0 ? (
                                        <>
                                            <td className="table-empty-text"></td>
                                            <td className="table-empty-text"></td>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    {mainTotalItemCgst > 0 ? (
                                        <>
                                            <td className="table-empty-text"></td>
                                            <td className="table-empty-text"></td>
                                            <td className="table-empty-text"></td>
                                            <td className="table-empty-text"></td>
                                        </>
                                    ) : (
                                        <>
                                            <td className="table-empty-text"></td>
                                            <td className="table-empty-text"></td>
                                        </>
                                    )}
                                    <td className="table-empty-text"></td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr className="table-body">
                                    <td className="table-head-text text-end"></td>
                                    <td className="table-head-text">Total</td>
                                    <td className="table-head-text text-center"></td>
                                    <td className="table-head-text text-end">
                                        {PackingChallanData?.total_quantity}
                                    </td>
                                    <td className="table-head-text text-end"></td>
                                    {mainTotalDiscount > 0 ? (
                                        <>
                                            <td className="table-head-text text-end"></td>
                                            <td className="table-head-text text-end">
                                                {mainTotalDiscount}
                                            </td>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    {mainTotalItemCgst > 0 ? (
                                        <>
                                            <td className="table-head-text text-end"></td>
                                            <td className="table-head-text text-end">
                                                {mainTotalItemCgst}
                                            </td>
                                            <td className="table-head-text text-end"></td>
                                            <td className="table-head-text text-end">
                                                {mainTotalItemSgst}
                                            </td>
                                        </>
                                    ) : (
                                        <>
                                            <td className="table-head-text text-end"></td>
                                            <td className="table-head-text text-end">
                                                {mainTotalItemIgst}
                                            </td>
                                        </>
                                    )}
                                    <td className="table-head-text text-end">
                                        {PackingChallanData?.totalAmount}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div className="row g-0">
                        <div
                            className="col-7 g-0"
                            style={{
                                border: "1px solid #000",
                                borderRight: "0px solid #000",
                            }}
                        >
                            <div className="box rounded-0 bg-transparent col-12 p-1">
                                <div
                                    className="text-start"
                                    style={{
                                        fontFamily: "Poppins",
                                        fontSize: 13,
                                        color: "#000",
                                        fontWeight: 800,
                                    }}
                                >
                                    Total Amount in Words :{" "}
                                    <span
                                        className="text-start"
                                        style={{
                                            fontFamily: "Poppins",
                                            fontSize: 13,
                                            color: "#000",
                                            fontWeight: 500,
                                        }}
                                    >
                                        Rs. {numberToWords(PackingChallanData?.net_amount > 0 ? parseInt(PackingChallanData?.net_amount) : 0)}{" "}
                                        Only
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="col-5 g-0">
                            <div className="box rounded-0 bg-transparent border-0">
                                <table className="bill-body-table bg-light">
                                    <tbody>
                                        <tr className="table-body">
                                            <td className="table-body-text"> Total Amt BFT :</td>
                                            <td className="table-body-text text-end">
                                                {" "}
                                                {PackingChallanData?.totalAmount}
                                            </td>
                                        </tr>
                                        <tr className="table-body">
                                            <td className="table-body-text"> Total GST :</td>
                                            <td className="table-body-text text-end">
                                                {" "}
                                                {PackingChallanData?.gst_amount}
                                            </td>
                                        </tr>
                                        <tr className="table-body">
                                            <td className="table-body-text"> Net Amount :</td>
                                            <td className="table-body-text text-end">
                                                {" "}
                                                {PackingChallanData?.net_amount}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div
                        className="Print-Footer row g-0"
                        style={{ border: "1px solid #000", borderTop: "0px solid #000" }}
                    >
                        <div className="col-7 py-4"></div>
                        <div className="col-5 pe-4 text-end">
                            <div
                                className="pt-2"
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: 13,
                                    color: "#000",
                                    fontWeight: 500,
                                }}
                            >
                                For{" "}
                                <span
                                    style={{
                                        fontFamily: "Poppins",
                                        fontSize: 14,
                                        color: "#000",
                                        fontWeight: 600,
                                    }}
                                >
                                    {UserDetail?.result?.user?.company_name}
                                </span>
                            </div>
                            <div
                                className="pt-4"
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: 13,
                                    color: "#000",
                                    fontWeight: 500,
                                }}
                            >
                                (Authorised Signatory)
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={Loader}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <div className="main-box">
                <ThemeProvider theme={theme}>
                    <div className="box-head transaction">
                        <Stack className="heading" alignItems="center" direction="row">
                            <IconButton
                                color="primary"
                                onClick={() => {
                                    navigate(`/CompanyDashboard`);
                                }}
                            >
                                <ArrowBackIosIcon sx={{ fontSize: "20px" }} />
                            </IconButton>
                            <Typography variant="h4">Packing challan</Typography>
                            {totalRecords ? (
                                <StyledTypography variant="caption">{totalRecords}</StyledTypography>
                            ) : (
                                <></>
                            )}
                        </Stack>
                        <Stack alignItems="center" direction="row">
                            {PermitData.result?.IsSearch === true ? (
                                <TextField
                                    id="Search"
                                    placeholder="Search"
                                    value={searchQuery}
                                    onChange={handleSearchChange}

                                />
                            ) : null}
                        </Stack>
                        {PermitData.result?.IsSearch === true ? (
                            <Stack alignItems="center" direction="row">
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={FilterWithDate}
                                            // onChange={(event) => {
                                            //     setFilterWithDate(event.target.checked)
                                            //     if (FromDate || ToDate) {
                                            //         setFromDate("")
                                            //         setToDate("")
                                            //         // dispatch(fetchData({}));
                                            //     }
                                            //     if (event.target.checked) {
                                            //         // setFromDate(cmpdetail?.StartDate)
                                            //         // setToDate(cmpdetail?.ExpiryDate)
                                            //         // dispatch(fetchData({}));
                                            //     }
                                            // }}
                                            onChange={(event) => {
                                                const checked = event.target.checked;

                                                setFilterWithDate(checked);
                                                setPage(1);

                                                if (!checked) {
                                                    setFromDate("");
                                                    setToDate("");

                                                    dispatch(
                                                        fetchData({
                                                            cmpdetail,
                                                            UserDetail,
                                                            page: 1,
                                                            limit: rowsPerPage,
                                                            search: searchQuery,
                                                            fromDate: "",
                                                            toDate: "",
                                                        })
                                                    );
                                                }
                                            }}
                                            sx={{ py: 0 }}
                                        />
                                    }
                                    label="Filter Date"
                                />
                                <ArrowDropDownIcon onClick={handleClick}
                                    sx={{
                                        display: "none", "@media (max-width: 1150px)": {
                                            display: FilterWithDate ? "inline" : "none"
                                        }
                                    }} />
                                <ThemeProvider theme={form}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs} locale={enGB}>
                                        <Popover
                                            id={"simple-popover"}
                                            open={filterDates}
                                            anchorEl={anchorEl}
                                            onClose={handleClose}
                                            anchorOrigin={{
                                                vertical: "top",
                                                horizontal: "right",
                                            }}
                                            sx={{
                                                "@media (min-width: 1150px)": {
                                                    display: "none"
                                                },
                                            }}
                                        >
                                            <Box sx={{
                                                display: FilterWithDate ? "flex" : "none", p: 1, gap: 1
                                            }}>
                                                <DatePicker
                                                    format="DD/MM/YYYY"
                                                    disabled={!FilterWithDate}
                                                    slotProps={{ textField: { placeholder: "Start Date" } }}
                                                    value={FromDate ? dayjs(FromDate) : null}
                                                    onChange={(newValue) =>
                                                        handleFromDate(
                                                            newValue?.format("YYYY-MM-DD")
                                                        )
                                                    }
                                                    renderInput={(params) => <TextField {...params} />}
                                                />
                                                <DatePicker
                                                    format="DD/MM/YYYY"
                                                    disabled={!FilterWithDate}
                                                    slotProps={{ textField: { placeholder: "End Date" } }}
                                                    value={ToDate ? dayjs(ToDate) : null}
                                                    onChange={(newValue) =>
                                                        handleToDate(
                                                            newValue?.format("YYYY-MM-DD")
                                                        )
                                                    }
                                                    renderInput={(params) => <TextField {...params} />}
                                                />
                                            </Box>
                                        </Popover>
                                        <Box sx={{
                                            display: FilterWithDate ? "flex" : "none",
                                            "@media (max-width: 1150px)": {
                                                display: "none"
                                            },
                                            gap: 1
                                        }}>
                                            <DatePicker
                                                format="DD/MM/YYYY"
                                                disabled={!FilterWithDate}
                                                slotProps={{ textField: { placeholder: "Start Date" } }}
                                                value={FromDate ? dayjs(FromDate) : null}
                                                onChange={(newValue) =>
                                                    handleFromDate(
                                                        newValue?.format("YYYY-MM-DD")
                                                    )
                                                }
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                            <DatePicker
                                                format="DD/MM/YYYY"
                                                disabled={!FilterWithDate}
                                                slotProps={{ textField: { placeholder: "End Date" } }}
                                                value={ToDate ? dayjs(ToDate) : null}
                                                onChange={(newValue) =>
                                                    handleToDate(
                                                        newValue?.format("YYYY-MM-DD")
                                                    )
                                                }
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                        </Box>
                                    </LocalizationProvider>
                                </ThemeProvider>
                            </Stack>
                        ) : null}
                        <Stack className="btns" alignItems="center" direction="row">
                            {PermitData.result?.IsPrint === true ? (
                                <>
                                    <Button variant="contained" startIcon={<SaveAltIcon />} onClick={handleDownloadCSV}>
                                        CSV
                                    </Button>
                                </>
                            ) : (
                                <></>
                            )}
                            {PermitData.result?.IsSave === true ? (
                                <Button
                                    onClick={() => {
                                        return navigate("AddPackingChallan");
                                    }}
                                    variant="contained"
                                >
                                    + New
                                </Button>
                            ) : (
                                <></>
                            )}
                        </Stack>
                    </div>
                    <Backdrop
                        sx={{ color: "#fff", zIndex: 9999 }}
                        open={Loader}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <DeleteDialog
                        modalOpen={modalOpenDelete}
                        handleModalClose={() => handleModalCloseDelete()}
                        executeConfirmed={() => handleModalOpenPassword()}
                    />
                    <PasswordDialog
                        modalOpen={modalOpenPassword}
                        handleModalClose={() => handleModalClosePassword()}
                        executeConfirmed={() => removeSaleBill()}
                    />

                    <div className="card-form-box transaction">
                        {status == "loading" ? (
                            <>
                                <div
                                    style={{
                                        height: "100%",
                                        display: "grid",
                                        placeContent: "center",
                                    }}
                                >
                                    <CircularProgress sx={{ ml: 1, mb: 1 }} />
                                    <Typography variant="subtitle2">Loading...</Typography>
                                </div>
                            </>
                        ) : (
                            <>
                                <Paper
                                    sx={{
                                        width: "100%", height: "100%", overflowY: "scroll",
                                        "::-webkit-scrollbar": {
                                            display: "none"
                                        }
                                    }}
                                >
                                    <TableContainer component={Paper} sx={{ height: "100%" }}>
                                        {status == "failed" || statusS == false ? (
                                            <>
                                                <div className="d-flex justify-content-center">
                                                    <img src={noData} />
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <Table
                                                    stickyHeader
                                                    sx={{ minWidth: 650 }}
                                                    size="small"
                                                    aria-label="a dense table"
                                                >
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell sx={{ fontWeight: 600 }}>
                                                                Challan No.
                                                            </TableCell>
                                                            <TableCell sx={{ fontWeight: 600 }}>
                                                                Date
                                                            </TableCell>
                                                            <TableCell sx={{ fontWeight: 600 }}>
                                                                Bill No.
                                                            </TableCell>
                                                            <TableCell sx={{ fontWeight: 600 }}>
                                                                Bill Date
                                                            </TableCell>
                                                            <TableCell sx={{ fontWeight: 600 }}>
                                                                Party
                                                            </TableCell>
                                                            <TableCell sx={{ fontWeight: 600 }}>
                                                                Transport
                                                            </TableCell>
                                                            <TableCell sx={{ fontWeight: 600 }}>
                                                                Qty
                                                            </TableCell>
                                                            <TableCell sx={{ fontWeight: 600 }}>
                                                                Taxable Amt
                                                            </TableCell>
                                                            <TableCell sx={{ fontWeight: 600 }}>
                                                                Total Amt
                                                            </TableCell>
                                                            <TableCell sx={{ fontWeight: 600 }}>
                                                                Status
                                                            </TableCell>
                                                            <TableCell
                                                                sx={{
                                                                    fontWeight: 600,
                                                                    position: "sticky",
                                                                    top: 0,
                                                                    right: 0,
                                                                    zIndex: 5,
                                                                    backgroundColor: "background.paper",
                                                                    minWidth: 120,
                                                                }}
                                                                align="center"
                                                            >
                                                                Action
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {paginatedData?.map((row, index) => {
                                                            return (
                                                                <TableRow hover key={index} sx={{ py: 0.5 }}>
                                                                    <TableCell sx={{ py: 0.5 }}>
                                                                        {row.purchase_no}
                                                                    </TableCell>
                                                                    <TableCell sx={{ py: 0.5 }}>
                                                                        {DateToShow(row.createdAt)}
                                                                    </TableCell>
                                                                    <TableCell sx={{ py: 0.5 }}>
                                                                        {row.bill_no}
                                                                    </TableCell>
                                                                    <TableCell sx={{ py: 0.5 }}>
                                                                        {DateToShow(row.bill_date)}
                                                                    </TableCell>
                                                                    <TableCell sx={{ py: 0.5 }}>
                                                                        {/* {row.supplier_name} */}
                                                                        {cmpdetail?.company_name}
                                                                    </TableCell>
                                                                    <TableCell sx={{ py: 0.5 }}>
                                                                        {row.transport}
                                                                    </TableCell>
                                                                    <TableCell sx={{ py: 0.5 }}>
                                                                        {row.total_quantity}
                                                                    </TableCell>
                                                                    <TableCell sx={{ py: 0.5 }}>
                                                                        {row.totalAmount}
                                                                    </TableCell>
                                                                    <TableCell sx={{ py: 0.5 }}>
                                                                        {row.net_amount}
                                                                    </TableCell>
                                                                    <TableCell sx={{ py: 0.5 }}>
                                                                        {!row?.is_downloaded ? (
                                                                            <Chip
                                                                                label="Pending"
                                                                                size="small"
                                                                                sx={{
                                                                                    bgcolor: "#F55050",
                                                                                    color: "#fff",
                                                                                    fontSize: "10px",
                                                                                }}
                                                                            />
                                                                        ) : (
                                                                            <Chip
                                                                                label="Downloaded"
                                                                                size="small"
                                                                                sx={{
                                                                                    bgcolor: "#2EB086",
                                                                                    color: "#fff",
                                                                                    fontSize: "10px",
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </TableCell>
                                                                    <TableCell
                                                                        align="center"
                                                                        sx={{
                                                                            py: 0.5,
                                                                            position: "sticky",
                                                                            right: 0,
                                                                            zIndex: 3,
                                                                            backgroundColor: "background.paper",
                                                                            minWidth: 120,

                                                                        }}>
                                                                        <Box
                                                                            display="flex"
                                                                            justifyContent="space-evenly"
                                                                        >
                                                                            {PermitData.result?.IsPrint ===
                                                                                true ? (
                                                                                <>
                                                                                    <IconButton
                                                                                        color="primary"
                                                                                        aria-label="print"
                                                                                        onClick={() => {
                                                                                            openPrint(row.id);
                                                                                        }}
                                                                                        sx={{ padding: 0, margin: 0 }}
                                                                                    >
                                                                                        <LocalPrintshopIcon
                                                                                            sx={{ fontSize: "20px" }}
                                                                                        />
                                                                                    </IconButton>
                                                                                </>
                                                                            ) : (
                                                                                <IconButton
                                                                                    disabled
                                                                                    aria-label="print"
                                                                                    sx={{ padding: 0, margin: 0 }}
                                                                                >
                                                                                    <LocalPrintshopIcon
                                                                                        sx={{ fontSize: "20px" }}
                                                                                    />
                                                                                </IconButton>
                                                                            )}
                                                                            {PermitData.result?.IsUpdate ===
                                                                                true ? (
                                                                                <>
                                                                                    <IconButton
                                                                                        color="primary"
                                                                                        aria-label="Edit"
                                                                                        onClick={() => {
                                                                                            navigate(
                                                                                                `EditPackingChallan/${row.id}`
                                                                                            );
                                                                                        }}
                                                                                        sx={{ padding: 0, margin: 0 }}
                                                                                    >
                                                                                        <ModeEditOutlinedIcon
                                                                                            sx={{ fontSize: "20px" }}
                                                                                        />
                                                                                    </IconButton>
                                                                                </>
                                                                            ) : (
                                                                                <IconButton
                                                                                    disabled
                                                                                    aria-label="edit"
                                                                                    sx={{ padding: 0, margin: 0 }}
                                                                                >
                                                                                    <ModeEditOutlinedIcon
                                                                                        sx={{ fontSize: "20px" }}
                                                                                    />
                                                                                </IconButton>
                                                                            )}
                                                                            {/* {PermitData.result?.IsDelete ===
                                                                                true ? (
                                                                                <>
                                                                                    <IconButton
                                                                                        color="primary"
                                                                                        aria-label="Delete"
                                                                                        onClick={() => deletePackingChallan(row)}
                                                                                        sx={{ padding: 0, margin: 0 }}
                                                                                    >
                                                                                        <DeleteOutlineOutlinedIcon
                                                                                            sx={{ fontSize: "20px" }}
                                                                                        />
                                                                                    </IconButton>
                                                                                </>
                                                                            ) : (
                                                                                <IconButton
                                                                                    disabled
                                                                                    aria-label="Delete"
                                                                                    sx={{ padding: 0, margin: 0 }}
                                                                                >
                                                                                    <DeleteOutlineOutlinedIcon
                                                                                        sx={{ fontSize: "20px" }}
                                                                                    />
                                                                                </IconButton>
                                                                            )} */}
                                                                            {/* {shouldReRender ? (
                                                                                <IconButton
                                                                                    aria-label="edit"
                                                                                    sx={{ padding: 0, margin: 0 }}
                                                                                >
                                                                                    <InfoIcon
                                                                                        sx={{ fontSize: "20px", color: "#b2b4b8" }}
                                                                                    />
                                                                                </IconButton>
                                                                            ) : null}
                                                                            {!shouldReRender && (
                                                                                <CustomizedTooltip
                                                                                    onClose={handleTooltipClose}
                                                                                    open={openTooltip[index]}
                                                                                    disableFocusListener
                                                                                    disableHoverListener
                                                                                    disableTouchListener
                                                                                    title={
                                                                                        <>
                                                                                            <Typography variant="overline" color="inherit">Creation Date: <b>{DateToShow(row.CreationDate)}</b></Typography><br />
                                                                                            <Typography variant="overline" color="inherit">Update Date &nbsp;&nbsp;&nbsp;: <b>{DateToShow(row.LastUpdateDate)}</b></Typography><br />
                                                                                            <Typography variant="overline" color="inherit">Save User &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: <b>{row.SaveUser}</b></Typography><br />
                                                                                            <Typography variant="overline" color="inherit">Update User &nbsp;&nbsp;&nbsp;&nbsp;: <b>{row.UpdateUser}</b></Typography><br />
                                                                                        </>
                                                                                    }
                                                                                >
                                                                                    <IconButton
                                                                                        ref={tooltipRef}
                                                                                        aria-label="edit"
                                                                                        sx={{ padding: 0, margin: 0 }}
                                                                                        onClick={() => handleTooltipOpen(index)}
                                                                                    >
                                                                                        <InfoIcon
                                                                                            sx={{ fontSize: "20px", color: "#b2b4b8" }}
                                                                                        />
                                                                                    </IconButton>
                                                                                </CustomizedTooltip>
                                                                            )} */}
                                                                        </Box>
                                                                    </TableCell>
                                                                </TableRow>
                                                            );
                                                        })}
                                                    </TableBody>
                                                </Table>
                                            </>
                                        )}
                                    </TableContainer>
                                </Paper>
                            </>
                        )}
                    </div>
                    <div className="pagination-box d-flex justify-content-end align-items-center">
                        {/* <RowPages
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={(value) => handleChangeRowsPerPage(value)}
                            All={totalRecords}
                        />
                        <Pagination
                            count={totalPages}
                            siblingCount={isMobile ? 0 : 1}
                            boundaryCount={isMobile ? 0 : 1}
                            onChange={handlePageChange}
                            color="primary"
                            size="small"
                        /> */}
                        <RowPages
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            All={result?.totalRecords || 0}
                        />

                        <Pagination
                            count={result?.totalPages || 0}
                            page={result?.page || page}
                            siblingCount={isMobile ? 0 : 1}
                            boundaryCount={isMobile ? 0 : 1}
                            onChange={handlePageChange}
                            color="primary"
                            size="small"
                        />
                    </div>
                </ThemeProvider>
            </div>
            <Toaster position="top-center" reverseOrder={false} />
        </>
    );
};

export default function TableData() {
    const dispatch = useDispatch();
    const { cmpdetail } = useSelector((state) => state.CompanyDetail);
    const UserDetail = useSelector((state) => state.UserDetail);
    const { result, status, error } = useSelector((state) => state.PackingChallanData);
    useEffect(() => {
        dispatch(
            fetchDataPK({
                cmpdetail,
                UserDetail,
                page: 1,
                limit: 30,
                search: "",
                fromDate: "",
                toDate: "",
            })
        );
    }, [dispatch]);

    return (
        <>
            <DataTableWithPagination
                // data={result?.data}
                // status={status}
                // statusS={result?.status}
                // fetchData={fetchDataPK}
                data={result?.data}
                result={result}
                status={status}
                statusS={result?.status}
                fetchData={fetchDataPK}
            />
        </>
    );
}


































// import React, { useState, useEffect, useRef } from "react";
// import { Toaster, toast } from "react-hot-toast";
// import { showToast } from "../../Helpers/showToast";
// import { useNavigate, useParams, useLocation } from "react-router-dom";
// import { API_URL } from "../../env";
// import { POST } from '../../Services/AxiosService';
// import { CustomStringify } from "../../Helpers/CustomStringify";
// import { DateToShow } from "../../Helpers/DateToShow";
// import { DateToShowSplit } from "../../Helpers/DateToShowSplit";
// import TypeCase from "../../Helpers/TypeCase";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchDataPK } from "../../Redux/TransactionsData/PackingChallanDataSlice";
// // ------------------------------------------------
// // https://piktochart.com/tips/flowchart-examples
// import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
// import { numberToWords } from "amount-to-words";
// import Paper from "@mui/material/Paper";
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
// import TableCell from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
// import TableHead from "@mui/material/TableHead";
// import TableRow from "@mui/material/TableRow";
// import dayjs from "dayjs";
// import Stack from "@mui/material/Stack";
// import TextField from "@mui/material/TextField";
// import Button from "@mui/material/Button";
// import IconButton from "@mui/material/IconButton";
// import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
// import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
// import InfoIcon from '@mui/icons-material/Info';
// import CloseIcon from "@mui/icons-material/Close";
// import Dialog from "@mui/material/Dialog";
// import DialogTitle from "@mui/material/DialogTitle";
// import DialogContent from "@mui/material/DialogContent";
// import Chip from "@mui/material/Chip";
// import Slide from "@mui/material/Slide";
// import Pagination from "@mui/material/Pagination";
// import Typography from "@mui/material/Typography";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import Checkbox from "@mui/material/Checkbox";
// import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
// import SaveAltIcon from '@mui/icons-material/SaveAlt';
// import Backdrop from "@mui/material/Backdrop";
// import CircularProgress from "@mui/material/CircularProgress";
// import { ArrowDropDownIcon } from "@mui/x-date-pickers/icons";
// import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { enGB } from "date-fns/locale";
// import Popover from "@mui/material/Popover";

// import noData from "../../Images/nodata.png";
// import Box from "@mui/material/Box";
// import { styled } from "@mui/material/styles";
// import { ThemeProvider, createTheme } from "@mui/material/styles";
// import { useTheme } from "@mui/system";
// import { useMediaQuery } from "@mui/material";
// import DeleteDialog from "../../Components/Dialog/DeleteDialog";
// import PasswordDialog from "../../Components/Dialog/PasswordDialog";
// import { format, toDate } from "date-fns";
// import RowPages from "../../Components/RowPages/RowPages";
// import { PrintReport } from "../../Components/Print/PrintReport";

// const Transition = React.forwardRef(function Transition(props, ref) {
//     return <Slide direction="up" ref={ref} {...props} />;
// });

// const CustomizedTooltip = styled(({ className, ...props }) => (
//     <Tooltip {...props} classes={{ popper: className }} />
// ))(({ theme }) => ({
//     [`& .${tooltipClasses.tooltip}`]: {
//         backgroundColor: '#e6e7eb',
//         color: '#2c2d2e',
//         maxWidth: 500,
//         border: "1px solid #3e3f40",
//         marginRight: "30px"
//     },
// }));

// // NOTE:
// // data, totalRecords and totalPages now all come from the backend (see TableData
// // at the bottom, and the fetchDataPK thunk). This component no longer filters,
// // searches, or slices data locally — it just tells the backend what it wants
// // (page, rowsPerPage, search, fromDate, toDate) and renders whatever comes back.
// const DataTableWithPagination = ({
//     data,          // current page of rows ONLY (backend already paginated/filtered this)
//     status,
//     statusS,
//     fetchData,
//     totalRecords,  // total matching rows, from backend
//     totalPages,    // total pages, from backend (or computed from totalRecords/rowsPerPage)
// }) => {
//     const [shouldReRender, setShouldReRender] = useState(false);
//     const { cmpdetail } = useSelector((state) => state.CompanyDetail);
//     const UserDetail = useSelector((state) => state.UserDetail);
//     const Theme = useSelector((state) => state.Theme);
//     const PermitData = useSelector((state) => state.PermitData);

//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//     const location = useLocation();
//     const Message = location.state;

//     const [Loader, setLoader] = useState(false);
//     const [deleteId, setDeleteId] = useState();

//     const [PackingChallanData, setPackingChallanData] = useState([]);
//     const [HsnDetailsArr, setHsnDetailsArr] = useState([]);
//     const [HsnTotalDetails, setHsnTotalDetails] = useState([]);

//     const [itemDataArray, setitemDataArray] = useState([]);

//     const [mainTotalDiscount, setMainTotalDiscount] = useState();
//     const [mainTotalItemCgst, setMainTotalItemCgst] = useState();
//     const [mainTotalItemSgst, setMainTotalItemSgst] = useState();
//     const [mainTotalItemIgst, setMainTotalItemIgst] = useState();

//     const StyledTypography = styled(Typography)(({ theme }) => ({
//         "&": {
//             background: Theme.primaryThemeColor,
//             color: "#fff",
//             borderRadius: "25px",
//             padding: " 0 5px 0 5px",
//             marginTop: "2px",
//             border: "2px solid white",
//             fontWeight: 600,
//             "@media (max-width: 768px)": {
//                 fontSize: "10px",
//             },
//         },
//     }));

//     const [page, setPage] = useState(1);
//     const [rowsPerPage, setRowsPerPage] = useState(30);

//     const [searchQuery, setSearchQuery] = useState("");

//     const [FilterWithDate, setFilterWithDate] = useState(false);
//     const [FromDate, setFromDate] = useState("");
//     const [ToDate, setToDate] = useState("");

//     // ---------------------------------------------------------------------
//     // CHANGED: no more client-side filteredData / paginatedData / slicing.
//     // `data` prop IS the page of rows to render, `totalRecords` IS the count.
//     // ---------------------------------------------------------------------
//     const paginatedData = data;

//     // ---------------------------------------------------------------------
//     // NEW: fetch from backend whenever page, rowsPerPage, search, or the
//     // date filters change. Search is debounced so we don't fire a request
//     // on every keystroke.
//     // ---------------------------------------------------------------------
//     const debounceRef = useRef(null);
//     const isFirstRun = useRef(true);

//     useEffect(() => {
//         if (debounceRef.current) clearTimeout(debounceRef.current);

//         const delay = searchQuery ? 400 : 0;

//         debounceRef.current = setTimeout(() => {
//             dispatch(
//                 fetchDataPK({
//                     cmpdetail,
//                     UserDetail,
//                     page,
//                     rowsPerPage,
//                     search: searchQuery,
//                     fromDate: FilterWithDate ? FromDate : "",
//                     toDate: FilterWithDate ? ToDate : "",
//                 })
//             );
//         }, delay);

//         return () => clearTimeout(debounceRef.current);
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [page, rowsPerPage, searchQuery, FromDate, ToDate, FilterWithDate]);

//     const [anchorEl, setAnchorEl] = useState(null);

//     const handleClick = (event) => {
//         setAnchorEl(event.currentTarget);
//     };

//     const handleClose = () => {
//         setAnchorEl(null);
//     };

//     const filterDates = Boolean(anchorEl);

//     const handleSearchChange = (e) => {
//         setSearchQuery(e.target.value);
//         setPage(1); // reset to first page on a new search
//     };

//     const handleFromDate = (value) => {
//         setFromDate(value);
//         setPage(1); // reset to first page when the filter changes
//     };

//     const handleToDate = (value) => {
//         setToDate(value);
//         setPage(1); // reset to first page when the filter changes
//     };

//     const handlePageChange = (event, value) => {
//         setPage(value);
//     };

//     const handleChangeRowsPerPage = (value) => {
//         setRowsPerPage(value);
//         setPage(1); // reset to first page when page size changes
//     };

//     const hexToRGBFade = (hex, fade) => {
//         hex = hex.replace("#", "");
//         // Parse the red, green, and blue components from the hex string
//         let r = parseInt(hex.substring(0, 2), 16);
//         let g = parseInt(hex.substring(2, 4), 16);
//         let b = parseInt(hex.substring(4, 6), 16);
//         // Return the RGB value
//         return `rgb(${r}, ${g}, ${b}, ${fade})`;
//     };

//     // ---------------------------------------------------------------------
//     // NOTE (CSV export): `data` is now only the current page. Exporting it
//     // as-is will only give you the visible rows, not everything matching
//     // the search/date filter. Use a dedicated "export all" backend call
//     // (no pagination applied) instead — see fetchAllPackingChallansForExport
//     // below for the shape to plug in once your backend route exists.
//     // ---------------------------------------------------------------------
//     const fetchAllPackingChallansForExport = async () => {
//         const requestData = CustomStringify({
//             Database: cmpdetail?.Database,
//             Password: cmpdetail?.Password,
//             Server: cmpdetail?.Server,
//             User_ID: cmpdetail?.User_ID,
//             Port: cmpdetail?.Port,
//             search: searchQuery,
//             fromDate: FilterWithDate ? FromDate : "",
//             toDate: FilterWithDate ? ToDate : "",
//             exportAll: true, // tell backend to skip pagination for this call
//         });

//         try {
//             const result = await POST(`/purchase/${cmpdetail?.key}/export`, requestData);
//             return result?.data || [];
//         } catch (error) {
//             showToast(error?.response?.data?.message || error?.message, "error");
//             return [];
//         }
//     };

//     const handleDownloadCSV = async () => {
//         setLoader(true);
//         const rowsForExport = await fetchAllPackingChallansForExport();
//         setLoader(false);

//         const csvData =
//             "Challan No.,Date,Bill No.,Bill Date,Party Name,Transport,Qty,Taxable Amt,Total Amount\n" +
//             rowsForExport?.map((row) => {
//                 return `"${row.purchase_no}","${DateToShow(row.createdAt)}","${row.bill_no}","${DateToShow(row.bill_date)}","${cmpdetail?.company_name}","${row?.transport}","${row.total_quantity}","${row.totalAmount}","${row.net_amount}"`;
//             }).join("\n");

//         const blob = new Blob([csvData], { type: "text/csv" });

//         const url = URL.createObjectURL(blob);
//         const a = document.createElement("a");
//         a.href = url;
//         a.download = "Packing_Challan.csv";
//         document.body.appendChild(a);
//         a.click();
//         document.body.removeChild(a);
//         URL.revokeObjectURL(url);
//     };

//     const tooltipRef = useRef(null);
//     const [openTooltip, setOpenTooltip] = useState(data?.map(() => false) || []);

//     const handleTooltipClose = () => {
//         setOpenTooltip((pre) => pre?.map(() => false));
//     };

//     const handleTooltipOpen = (index) => {
//         setOpenTooltip((pre) => pre?.map((item, ind) => index == ind ? !item : item));

//         setShouldReRender(true);
//         setTimeout(() => setShouldReRender(false), 1);
//     };

//     useEffect(() => {
//         setOpenTooltip(data?.map(() => false) || []);
//     }, [data]);

//     useEffect(() => {
//         const handleClickAway = (event) => {
//             if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
//                 setOpenTooltip((pre) => pre?.map(() => false));
//             }
//         };

//         document.addEventListener('mousedown', handleClickAway);
//         return () => {
//             document.removeEventListener('mousedown', handleClickAway);
//         };
//     }, []);

//     const [modalOpenDelete, setModalOpenDelete] = useState(false);
//     const [modalOpenPassword, setModalOpenPassword] = useState(false);

//     const handleModalOpenDelete = () => {
//         setModalOpenDelete(true);
//     };
//     const handleModalCloseDelete = () => {
//         setModalOpenDelete(false);
//     };

//     const handleModalOpenPassword = () => {
//         setModalOpenPassword(true);
//     };
//     const handleModalClosePassword = () => {
//         setModalOpenPassword(false);
//     };

//     const openPrint = (id) => {
//         getPackingChallanById(id);
//     };

//     const setMainTotalData = (newItemDataArr) => {
//         var mainTotQty = 0;
//         var mainTotDis = 0;
//         var mainTotTaxAmt = 0;
//         var mainTotItemCgst = 0;
//         var mainTotItemSgst = 0;
//         var mainTotItemIgst = 0;
//         var mainTotAmt = 0;

//         newItemDataArr?.map((item) => {
//             mainTotQty = mainTotQty + Number(item?.qty);
//             mainTotDis = mainTotDis + Number(item?.discount_amount);
//             mainTotTaxAmt = mainTotTaxAmt + Number(item?.amountbft);
//             mainTotItemCgst = mainTotItemCgst + Number(item?.cgstamt);
//             mainTotItemSgst = mainTotItemSgst + Number(item?.sgstamt);
//             mainTotItemIgst = mainTotItemIgst + Number(item?.igstamt);
//             mainTotAmt = mainTotAmt + Number(item?.amount);
//         });

//         setMainTotalDiscount(mainTotDis?.toFixed(2));
//         setMainTotalItemCgst(mainTotItemCgst?.toFixed(2));
//         setMainTotalItemSgst(mainTotItemSgst?.toFixed(2));
//         setMainTotalItemIgst(mainTotItemIgst?.toFixed(2));
//     };

//     const getPackingChallanById = async (id) => {
//         setLoader(true);
//         const PackingChallan = paginatedData?.find((item) => item?.id == id);

//         setPackingChallanData(PackingChallan);
//         let newItemDataArr = PackingChallan?.OrderDesign?.map((item) => {
//             return { ...item, amountbft: (Number(item?.qty) * Number(item?.rate)).toFixed(2), cgstamt: ((Number(item?.qty) * Number(item?.rate)) * ((item?.gsttype?.includes("cgst") ? item?.cgst : 0) / 100)).toFixed(2), sgstamt: ((Number(item?.qty) * Number(item?.rate)) * ((item?.gsttype?.includes("sgst") ? item?.sgst : 0) / 100)).toFixed(2), igstamt: ((Number(item?.qty) * Number(item?.rate)) * ((item?.gsttype?.includes("igst") ? item?.igst : 0) / 100)).toFixed(2), amount: ((Number(item?.qty) * Number(item?.rate)) + (Number(item?.qty) * Number(item?.rate)) * (item?.totalgst / 100)).toFixed(2) }
//         });
//         setitemDataArray(newItemDataArr);
//         setMainTotalData(newItemDataArr);

//         setLoader(false);
//         setTimeout(() => {
//             handlePrintReport();
//         }, 500);

//         setShouldReRender(true);
//         setTimeout(() => setShouldReRender(false), 1);
//     };

//     const removeSaleBill = async () => {
//         setLoader(true);
//         var myHeaders = new Headers();
//         myHeaders.append("Access-Control-Allow-Origin", "*");
//         myHeaders.append("Content-Type", "application/json");

//         let data = paginatedData?.find((item) => item?.id == deleteId);

//         var rawData = CustomStringify({
//             et_ledger_id: data?.et_ledger_id,
//             supplierId: data?.supplierId,
//             party: data?.party,
//             supplier_name: data?.supplier_name,
//             address: data?.address,
//             mobile_no: data?.mobile_no,
//             GSTIN: data?.GSTIN,
//             PINCode: data?.PINCode,
//             et_state_id: data?.et_state_id,
//             state: data?.state,
//             et_city_id: data?.et_city_id,
//             city: data?.city,
//             et_broker_id: data?.et_broker_id,
//             broker: data?.broker,
//             bill_no: data?.bill_no,
//             bill_date: data?.bill_date,
//             et_transport_id: data?.et_transport_id,
//             transport: data?.transport,
//             total_quantity: data?.total_quantity,
//             totalAmount: data?.totalAmount,
//             gst_amount: data?.gst_amount,
//             net_amount: data?.net_amount,
//             OrderDesign: data?.OrderDesign,
//             orderId: data?.orderId,
//             orderdate: data?.orderdate,
//             order_no: data?.order_no,
//             is_cancel: true,
//         });

//         var requestOptions = {
//             method: "PATCH",
//             headers: myHeaders,
//             body: rawData,
//             redirect: "follow",
//         };

//         fetch(`${API_URL}/purchase/${cmpdetail?.key}/${deleteId}`, requestOptions)
//             .then((response) => response.json())
//             .then((result) => {
//                 if (result?.success === true) {
//                     handleModalCloseDelete();
//                     setLoader(false);
//                     showToast("Deleted Successfully", "success");
//                     dispatch(fetchDataPK({ cmpdetail, UserDetail, page, rowsPerPage, search: searchQuery, fromDate: FilterWithDate ? FromDate : "", toDate: FilterWithDate ? ToDate : "" }));
//                 } else {
//                     setLoader(false);
//                     showToast(result?.message, "error");
//                 }
//             })
//             .catch((error) => {
//                 setLoader(false);
//                 showToast("API Error", "error");
//                 console.log(error);
//             });
//     };

//     const deletePackingChallan = (row) => {
//         handleModalOpenDelete();
//         setDeleteId(row?.id);
//     };

//     useEffect(() => {
//         const keyEnter = (event) => {
//             if (event.altKey) {
//                 event.preventDefault();
//                 switch (event.key) {
//                     case "n":
//                         navigate("AddPackingChallan");
//                         break;
//                     default:
//                         break;
//                 }
//             }
//         };

//         document.addEventListener("keydown", keyEnter);

//         return () => {
//             document.removeEventListener("keydown", keyEnter);
//         };
//     });

//     useEffect(() => {
//         if (Message) {
//             showToast(Message, "success");
//             navigate(location.pathname, { replace: true });
//         }
//     }, []);


//     const printRef = useRef();
//     const PrintReportRef = useRef(null);

//     const handlePrintReport = () => {
//         if (PrintReportRef.current) {
//             PrintReportRef.current.printReport();
//         }
//     };

//     const Muitheme = useTheme();
//     const isMobile = useMediaQuery(Muitheme.breakpoints.down("sm"));

//     const theme = createTheme({
//         palette: {
//             primary: {
//                 main: Theme.primaryThemeColor,
//             },
//         },
//         typography: {
//             fontFamily: "Poppins",
//             h4: {
//                 fontWeight: "500",
//                 fontSize: "20px",
//                 "@media (max-width: 768px)": {
//                     fontSize: "16px",
//                 },
//             },
//             subtitle2: {
//                 "@media (max-width: 768px)": {
//                     display: "none"
//                 },
//             }
//         },
//         components: {
//             MuiInputBase: {
//                 styleOverrides: {
//                     root: {
//                         fontSize: "13px",
//                         height: "28px",
//                         width: "25vw",
//                         minWidth: "100px",
//                         background: "#fff",
//                     },
//                 },
//             },
//             MuiInputLabel: {
//                 styleOverrides: {
//                     root: {
//                         fontSize: "14px",
//                         marginTop: "-12px",
//                     },
//                 },
//             },
//             MuiButton: {
//                 styleOverrides: {
//                     root: {
//                         color: "#fff",
//                         fontSize: "13px",
//                         maxWidth: "260px",
//                         fontSize: "13px",
//                         maxWidth: "260px",
//                         height: "28px",
//                         padding: "12px 8px 12px 8px",
//                         fontWeight: 500,
//                         "@media (max-width: 768px)": {
//                             fontSize: "11px",
//                             padding: "10px 5px 10px 5px",
//                         },
//                     },
//                 },
//             },
//             MuiFormControlLabel: {
//                 styleOverrides: {
//                     label: {
//                         fontSize: "16px",
//                         "@media (max-width: 768px)": {
//                             fontSize: "13px",
//                         },
//                     },
//                 },
//             },
//             MuiTableCell: {
//                 styleOverrides: {
//                     root: {
//                         borderBottom: "1px solid #9a9da1",
//                     },
//                     head: {
//                         "&::after": {
//                             content: '""',
//                             position: "absolute",
//                             top: 0,
//                             left: 0,
//                             right: 0,
//                             bottom: 0,
//                             backgroundColor: hexToRGBFade(Theme.primaryThemeColor, 0.4),
//                             zIndex: -1,
//                         },
//                         whiteSpace: "nowrap",
//                         width: "auto",
//                         "@media (max-width: 768px)": {
//                             fontSize: "13px",
//                             padding: "2px 16px"
//                         },
//                     },
//                     body: {
//                         whiteSpace: "nowrap",
//                         width: "auto",
//                         "@media (max-width: 768px)": {
//                             fontSize: "13px",
//                             padding: "2px 16px"
//                         },
//                     },
//                 },
//             },
//         },
//     });

//     const form = createTheme({
//         palette: {
//             primary: {
//                 main: Theme.primaryThemeColor,
//             },
//         },
//         typography: {
//             fontFamily: "Poppins",
//         },
//         components: {
//             MuiInputBase: {
//                 styleOverrides: {
//                     root: {
//                         fontSize: "15px",
//                         height: "28px",
//                         width: "150px",
//                         background: "#fff",
//                     },
//                 },
//             },
//             MuiInputLabel: {
//                 styleOverrides: {
//                     root: {
//                         fontSize: "14px",
//                         marginTop: "-10px",
//                     },
//                 },
//             },
//         },
//     });

//     return (
//         <>
//             <PrintReport TxnName={"PackingChallan"} printRef={printRef} Led_Whatsaap={""} Led_Email={""} SONO={PackingChallanData?.purchase_no} EmailBSMSDetails={""} handleModalCloseEmail={null} Brok_Whatsapp={""} handleModalCloseBSMS={null} printRefFN={""} ref={PrintReportRef} />

//             <div className="print-box" ref={printRef} style={{ display: "none" }}>
//                 <div className="container-fluid mt-3 print-only">
//                     <h2
//                         style={{
//                             fontFamily: "Poppins",
//                             fontSize: 22,
//                             color: "#000",
//                             fontWeight: 600,
//                             textAlign: "center"
//                         }}
//                     >
//                         {UserDetail?.result?.user?.company_name}
//                     </h2>
//                     <div className="d-flex" style={{ width: "100%", alignItems: "center" }}>
//                         <div style={{ width: "33%", textAlign: "start" }}>
//                             {/* <img src={cmpdetail?.logoImg} alt="logo" style={{ width: "90%" }} /> */}
//                         </div>
//                         <div style={{ width: "33%", textAlign: "center" }}>
//                             <h6
//                                 style={{
//                                     fontFamily: "Poppins",
//                                     fontSize: 14,
//                                     color: "#000",
//                                     fontWeight: 500,
//                                 }}
//                             >
//                                 {UserDetail?.result?.user?.address ? UserDetail?.result?.user?.address + "," : null}{" "}
//                                 {UserDetail?.result?.user?.state} {UserDetail?.result?.user?.city} ({UserDetail?.result?.user?.pin_code})
//                             </h6>
//                             <h6
//                                 style={{
//                                     fontFamily: "Poppins",
//                                     fontSize: 14,
//                                     color: "#000",
//                                     fontWeight: 500,
//                                 }}
//                             >
//                                 {UserDetail?.result?.user?.mobile_no}{" "}
//                             </h6>
//                             <h6
//                                 style={{
//                                     fontFamily: "Poppins",
//                                     fontSize: 14,
//                                     color: "#000",
//                                     fontWeight: 500,
//                                 }}
//                             >
//                                 {UserDetail?.result?.user?.Email}
//                             </h6>
//                             <div
//                                 style={{
//                                     fontFamily: "Poppins",
//                                     fontSize: 13,
//                                     color: "#000",
//                                     fontWeight: 600,
//                                 }}
//                             >
//                                 GSTNo. {UserDetail?.result?.user?.GSTIN}
//                             </div>
//                             <h6
//                                 style={{
//                                     fontFamily: "Poppins",
//                                     fontSize: 15,
//                                     color: "#000",
//                                     fontWeight: 600,
//                                     margin: "5px 0 5px 0",
//                                 }}
//                             >
//                                 TAX CHALLAN
//                             </h6>
//                         </div>
//                         <div style={{ width: "33%", textAlign: "end" }}>
//                             &nbsp;
//                         </div>
//                     </div>

//                     <div className="row mt-2 g-0" style={{ border: "1px solid #000" }}>
//                         <div className="col-6" style={{ borderRight: "1px solid #000" }}>
//                             <div className="box rounded-0 p-1 bg-transparent">
//                                 <div className="row">
//                                     <div
//                                         className="col-3"
//                                         style={{
//                                             fontFamily: "Poppins",
//                                             fontSize: 12,
//                                             color: "#000",
//                                             fontWeight: 500,
//                                             paddingRight: 0
//                                         }}
//                                     >
//                                         Challan No.
//                                     </div>
//                                     <div
//                                         className="text-start col-5"
//                                         style={{
//                                             fontFamily: "Poppins",
//                                             fontSize: 12,
//                                             color: "#000",
//                                             fontWeight: 600,
//                                             paddingLeft: 0,
//                                             paddingRight: 0
//                                         }}
//                                     >
//                                         :&nbsp; {PackingChallanData?.purchase_no}
//                                     </div>
//                                     <div
//                                         className="col-1"
//                                         style={{
//                                             fontFamily: "Poppins",
//                                             fontSize: 12,
//                                             color: "#000",
//                                             fontWeight: 500,
//                                             paddingLeft: 0,
//                                             paddingRight: 0
//                                         }}
//                                     >
//                                         Date
//                                     </div>
//                                     <div
//                                         className="text-start col-3"
//                                         style={{
//                                             fontFamily: "Poppins",
//                                             fontSize: 11.5,
//                                             color: "#000",
//                                             fontWeight: 600,
//                                             paddingLeft: 0,
//                                             paddingRight: 0
//                                         }}
//                                     >
//                                         :&nbsp;{" "}
//                                         {DateToShow(PackingChallanData?.createdAt)}
//                                     </div>
//                                     <div
//                                         className="col-3"
//                                         style={{
//                                             fontFamily: "Poppins",
//                                             fontSize: 12,
//                                             color: "#000",
//                                             fontWeight: 500,
//                                             paddingRight: 0
//                                         }}
//                                     >
//                                         Bill No.
//                                     </div>
//                                     <div
//                                         className="text-start col-4"
//                                         style={{
//                                             fontFamily: "Poppins",
//                                             fontSize: 12,
//                                             color: "#000",
//                                             fontWeight: 600,
//                                             paddingLeft: 0,
//                                             paddingRight: 0
//                                         }}
//                                     >
//                                         :&nbsp; {PackingChallanData?.bill_no}
//                                     </div>
//                                     <div
//                                         className="col-2"
//                                         style={{
//                                             fontFamily: "Poppins",
//                                             fontSize: 12,
//                                             color: "#000",
//                                             fontWeight: 500,
//                                             paddingLeft: 0,
//                                             paddingRight: 0
//                                         }}
//                                     >
//                                         Bill Date
//                                     </div>
//                                     <div
//                                         className="text-start col-3"
//                                         style={{
//                                             fontFamily: "Poppins",
//                                             fontSize: 11.5,
//                                             color: "#000",
//                                             fontWeight: 600,
//                                             paddingLeft: 0,
//                                             paddingRight: 0
//                                         }}
//                                     >
//                                         :&nbsp;{" "}
//                                         {DateToShow(PackingChallanData?.bill_date)}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="col-6">
//                             <div className="box rounded-0 p-1 border-0 bg-transparent">
//                                 <div className="row">
//                                     <div
//                                         className="col-3"
//                                         style={{
//                                             fontFamily: "Poppins",
//                                             fontSize: 12,
//                                             color: "#000",
//                                             fontWeight: 500,
//                                             paddingRight: 0
//                                         }}
//                                     >
//                                         Agent
//                                     </div>
//                                     <div
//                                         className="text-start col-9"
//                                         style={{
//                                             fontFamily: "Poppins",
//                                             fontSize: 12,
//                                             color: "#000",
//                                             fontWeight: 600,
//                                             paddingLeft: 0,
//                                             paddingRight: 0
//                                         }}
//                                     >
//                                         :&nbsp; {PackingChallanData?.broker}
//                                     </div>
//                                     <div
//                                         className="col-3"
//                                         style={{
//                                             fontFamily: "Poppins",
//                                             fontSize: 12,
//                                             color: "#000",
//                                             fontWeight: 500,
//                                             paddingRight: 0
//                                         }}
//                                     >
//                                         Transport
//                                     </div>
//                                     <div
//                                         className="text-start col-9"
//                                         style={{
//                                             fontFamily: "Poppins",
//                                             fontSize: 12,
//                                             color: "#000",
//                                             fontWeight: 600,
//                                             paddingLeft: 0,
//                                             paddingRight: 0
//                                         }}
//                                     >
//                                         :&nbsp; {PackingChallanData?.transport}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                     <div className="row g-0">
//                         <div
//                             className="col-12"
//                             style={{
//                                 borderLeft: "1px solid #000",
//                                 borderRight: "1px solid #000",
//                                 textAlign: "center",
//                             }}
//                         >
//                             <div className="box rounded-0 p-1 bg-transparent">
//                                 <div
//                                     style={{
//                                         fontFamily: "Poppins",
//                                         fontSize: 12,
//                                         color: "#000",
//                                         fontWeight: 600,
//                                     }}
//                                 >
//                                     Details of Receiver | Billed To
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                     <div
//                         className="row g-0"
//                         style={{
//                             border: "1px solid #000",
//                             borderBottom: "0px solid #000",
//                         }}
//                     >
//                         <div className="col-12">
//                             <div className="box rounded-0 p-1 bg-transparent border-0">
//                                 <div className="row">
//                                     <div
//                                         className="col-2"
//                                         style={{
//                                             fontFamily: "Poppins",
//                                             fontSize: 12,
//                                             color: "#000",
//                                             fontWeight: 500,
//                                             paddingRight: 0
//                                         }}
//                                     >
//                                         Name
//                                     </div>
//                                     <div
//                                         className="text-start col-10"
//                                         style={{
//                                             fontFamily: "Poppins",
//                                             fontSize: 14,
//                                             color: "#000",
//                                             fontWeight: 600,
//                                             paddingLeft: 0,
//                                             paddingRight: 0
//                                         }}
//                                     >
//                                         :&nbsp;{PackingChallanData?.is_cancel ? "" : cmpdetail?.company_name}
//                                     </div>
//                                 </div>
//                                 <div className="row">
//                                     <div
//                                         className="col-2"
//                                         style={{
//                                             fontFamily: "Poppins",
//                                             fontSize: 12,
//                                             color: "#000",
//                                             fontWeight: 500,
//                                             paddingRight: 0
//                                         }}
//                                     >
//                                         Address
//                                     </div>
//                                     <div
//                                         className="text-start col-10"
//                                         style={{
//                                             fontFamily: "Poppins",
//                                             fontSize: 12,
//                                             color: "#000",
//                                             fontWeight: 600,
//                                             paddingLeft: 0,
//                                             paddingRight: 0
//                                         }}
//                                     >
//                                         :&nbsp; {PackingChallanData?.is_cancel ? "" : `${cmpdetail?.Address ? cmpdetail?.Address + "," : null} ${cmpdetail?.city} ${cmpdetail?.pin_code ? ", " + cmpdetail?.pin_code : null}`}
//                                     </div>
//                                     <div
//                                         className="col-2"
//                                         style={{
//                                             fontFamily: "Poppins",
//                                             fontSize: 12,
//                                             color: "#000",
//                                             fontWeight: 500,
//                                             paddingRight: 0
//                                         }}
//                                     >
//                                         Mobile No.
//                                     </div>
//                                     <div
//                                         className="text-start col-10"
//                                         style={{
//                                             fontFamily: "Poppins",
//                                             fontSize: 12,
//                                             color: "#000",
//                                             fontWeight: 600,
//                                             paddingLeft: 0,
//                                             paddingRight: 0
//                                         }}
//                                     >
//                                         :&nbsp;{PackingChallanData?.is_cancel ? "" : cmpdetail?.mobile_no}
//                                     </div>
//                                     <div
//                                         className="col-2"
//                                         style={{
//                                             fontFamily: "Poppins",
//                                             fontSize: 12,
//                                             color: "#000",
//                                             fontWeight: 500,
//                                             paddingRight: 0
//                                         }}
//                                     >
//                                         GST No.
//                                     </div>
//                                     <div
//                                         className="text-start col-10"
//                                         style={{
//                                             fontFamily: "Poppins",
//                                             fontSize: 12,
//                                             color: "#000",
//                                             fontWeight: 600,
//                                             paddingLeft: 0,
//                                             paddingRight: 0
//                                         }}
//                                     >
//                                         :&nbsp;{PackingChallanData?.is_cancel ? "" : cmpdetail?.gst_no}
//                                     </div>
//                                     <div
//                                         className="col-2"
//                                         style={{
//                                             fontFamily: "Poppins",
//                                             fontSize: 12,
//                                             color: "#000",
//                                             fontWeight: 500,
//                                             paddingRight: 0
//                                         }}
//                                     >
//                                         State
//                                     </div>
//                                     <div
//                                         className="text-start col-10"
//                                         style={{
//                                             fontFamily: "Poppins",
//                                             fontSize: 12,
//                                             color: "#000",
//                                             fontWeight: 600,
//                                             paddingLeft: 0,
//                                             paddingRight: 0
//                                         }}
//                                     >
//                                         :&nbsp;{" "}
//                                         {PackingChallanData?.is_cancel ? "" : cmpdetail?.state}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                     <div className="bill-body">
//                         <table className="bill-body-table">
//                             <thead>
//                                 <tr className="table-head">
//                                     <th className="table-head-text text-end">SN.</th>
//                                     <th className="table-head-text">Description</th>
//                                     <th className="table-head-text text-center">HSN</th>
//                                     <th className="table-head-text text-end">QTY</th>
//                                     <th className="table-head-text text-end">RATE</th>
//                                     {mainTotalDiscount > 0 ? (
//                                         <>
//                                             <th colspan="2" className="table-head-text text-end">
//                                                 DISCOUNT
//                                             </th>
//                                         </>
//                                     ) : (
//                                         <></>
//                                     )}
//                                     {mainTotalItemCgst > 0 ? (
//                                         <>
//                                             <th colspan="2" className="table-head-text text-center">
//                                                 CGST
//                                             </th>
//                                             <th colspan="2" className="table-head-text text-center">
//                                                 SGST
//                                             </th>
//                                         </>
//                                     ) : (
//                                         <th colspan="2" className="table-head-text text-center">
//                                             IGST
//                                         </th>
//                                     )}
//                                     <th className="table-head-text text-end">AMT BFT</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {PackingChallanData?.OrderDesign?.map((item, index) => (
//                                     <tr className="table-body" key={index}>
//                                         <td
//                                             className="table-body-text text-end"
//                                             style={{ width: "30px" }}
//                                         >
//                                             {index + 1}
//                                         </td>
//                                         <td className="table-body-text">
//                                             {item?.supply_design} - {item?.product} ({item?.design_no})
//                                         </td>
//                                         <td
//                                             className="table-body-text text-center"
//                                             style={{ width: "60px" }}
//                                         >
//                                             {item?.hsn_code}
//                                         </td>
//                                         <td
//                                             className="table-body-text text-end"
//                                             style={{ width: "60px" }}
//                                         >
//                                             {item?.qty ? item?.qty : null}
//                                         </td>
//                                         <td
//                                             className="table-body-text text-end"
//                                             style={{ width: "60px" }}
//                                         >
//                                             {item?.rate ? item?.rate : null}
//                                         </td>
//                                         {mainTotalDiscount > 0 ? (
//                                             <>
//                                                 <td
//                                                     className="table-body-text text-end"
//                                                     style={{ width: "50px" }}
//                                                 >
//                                                     <b>
//                                                         {item?.discount_per
//                                                             ? item?.discount_per + "%"
//                                                             : ""}
//                                                     </b>
//                                                 </td>
//                                                 <td
//                                                     className="table-body-text text-end"
//                                                     style={{ width: "50px" }}
//                                                 >
//                                                     {item?.discount_amount
//                                                         ? item?.discount_amount
//                                                         : ""}
//                                                 </td>
//                                             </>
//                                         ) : (
//                                             <></>
//                                         )}
//                                         {mainTotalItemCgst > 0 ? (
//                                             <>
//                                                 <td
//                                                     className="table-body-text text-end"
//                                                     style={{ width: "50px" }}
//                                                 >
//                                                     <b>
//                                                         {item?.cgst
//                                                             ? item?.cgst + "%"
//                                                             : ""}
//                                                     </b>
//                                                 </td>
//                                                 <td
//                                                     className="table-body-text text-end"
//                                                     style={{ width: "50px" }}
//                                                 >

//                                                     {((Number(item?.qty) * (Number(item?.rate) - ((Number(item?.discount_per) / 100) * Number(item?.rate)))) * ((item?.gsttype?.includes("cgst") ? item?.cgst : 0) / 100)).toFixed(2)}
//                                                 </td>
//                                                 <td
//                                                     className="table-body-text text-end"
//                                                     style={{ width: "50px" }}
//                                                 >
//                                                     <b>
//                                                         {item?.sgst
//                                                             ? item?.sgst + "%"
//                                                             : ""}
//                                                     </b>
//                                                 </td>
//                                                 <td
//                                                     className="table-body-text text-end"
//                                                     style={{ width: "50px" }}
//                                                 >
//                                                     {((Number(item?.qty) * (Number(item?.rate) - ((Number(item?.discount_per) / 100) * Number(item?.rate)))) * ((item?.gsttype?.includes("sgst") ? item?.sgst : 0) / 100)).toFixed(2)}
//                                                 </td>
//                                             </>
//                                         ) : (
//                                             <>
//                                                 <td
//                                                     className="table-body-text text-end"
//                                                     style={{ width: "50px" }}
//                                                 >
//                                                     <b>
//                                                         {item?.igst
//                                                             ? item?.igst + "%"
//                                                             : ""}
//                                                     </b>
//                                                 </td>
//                                                 <td
//                                                     className="table-body-text text-end"
//                                                     style={{ width: "50px" }}
//                                                 >
//                                                     {((Number(item?.qty) * (Number(item?.rate) - ((Number(item?.discount_per) / 100) * Number(item?.rate)))) * ((item?.gsttype?.includes("igst") ? item?.igst : 0) / 100)).toFixed(2)}
//                                                 </td>
//                                             </>
//                                         )}
//                                         <td
//                                             className="table-body-text text-end"
//                                             style={{ width: "80px" }}
//                                         >
//                                             {(Number(item?.qty) * (Number(item?.rate) - ((Number(item?.discount_per) / 100) * Number(item?.rate)))).toFixed(2)}
//                                         </td>
//                                     </tr>
//                                 ))}
//                                 <tr
//                                     className="table-body"
//                                     style={{
//                                         height: `calc(${"20vh"} - (${"35px"}*${PackingChallanData?.OrderDesign?.length
//                                             }))`,
//                                     }}
//                                 >
//                                     <td className="table-empty-text"></td>
//                                     <td className="table-empty-text"></td>
//                                     <td className="table-empty-text"></td>
//                                     <td className="table-empty-text"></td>
//                                     <td className="table-empty-text"></td>
//                                     {mainTotalDiscount > 0 ? (
//                                         <>
//                                             <td className="table-empty-text"></td>
//                                             <td className="table-empty-text"></td>
//                                         </>
//                                     ) : (
//                                         <></>
//                                     )}
//                                     {mainTotalItemCgst > 0 ? (
//                                         <>
//                                             <td className="table-empty-text"></td>
//                                             <td className="table-empty-text"></td>
//                                             <td className="table-empty-text"></td>
//                                             <td className="table-empty-text"></td>
//                                         </>
//                                     ) : (
//                                         <>
//                                             <td className="table-empty-text"></td>
//                                             <td className="table-empty-text"></td>
//                                         </>
//                                     )}
//                                     <td className="table-empty-text"></td>
//                                 </tr>
//                             </tbody>
//                             <tfoot>
//                                 <tr className="table-body">
//                                     <td className="table-head-text text-end"></td>
//                                     <td className="table-head-text">Total</td>
//                                     <td className="table-head-text text-center"></td>
//                                     <td className="table-head-text text-end">
//                                         {PackingChallanData?.total_quantity}
//                                     </td>
//                                     <td className="table-head-text text-end"></td>
//                                     {mainTotalDiscount > 0 ? (
//                                         <>
//                                             <td className="table-head-text text-end"></td>
//                                             <td className="table-head-text text-end">
//                                                 {mainTotalDiscount}
//                                             </td>
//                                         </>
//                                     ) : (
//                                         <></>
//                                     )}
//                                     {mainTotalItemCgst > 0 ? (
//                                         <>
//                                             <td className="table-head-text text-end"></td>
//                                             <td className="table-head-text text-end">
//                                                 {mainTotalItemCgst}
//                                             </td>
//                                             <td className="table-head-text text-end"></td>
//                                             <td className="table-head-text text-end">
//                                                 {mainTotalItemSgst}
//                                             </td>
//                                         </>
//                                     ) : (
//                                         <>
//                                             <td className="table-head-text text-end"></td>
//                                             <td className="table-head-text text-end">
//                                                 {mainTotalItemIgst}
//                                             </td>
//                                         </>
//                                     )}
//                                     <td className="table-head-text text-end">
//                                         {PackingChallanData?.totalAmount}
//                                     </td>
//                                 </tr>
//                             </tfoot>
//                         </table>
//                     </div>
//                     <div className="row g-0">
//                         <div
//                             className="col-7 g-0"
//                             style={{
//                                 border: "1px solid #000",
//                                 borderRight: "0px solid #000",
//                             }}
//                         >
//                             <div className="box rounded-0 bg-transparent col-12 p-1">
//                                 <div
//                                     className="text-start"
//                                     style={{
//                                         fontFamily: "Poppins",
//                                         fontSize: 13,
//                                         color: "#000",
//                                         fontWeight: 800,
//                                     }}
//                                 >
//                                     Total Amount in Words :{" "}
//                                     <span
//                                         className="text-start"
//                                         style={{
//                                             fontFamily: "Poppins",
//                                             fontSize: 13,
//                                             color: "#000",
//                                             fontWeight: 500,
//                                         }}
//                                     >
//                                         Rs. {numberToWords(PackingChallanData?.net_amount > 0 ? parseInt(PackingChallanData?.net_amount) : 0)}{" "}
//                                         Only
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="col-5 g-0">
//                             <div className="box rounded-0 bg-transparent border-0">
//                                 <table className="bill-body-table bg-light">
//                                     <tbody>
//                                         <tr className="table-body">
//                                             <td className="table-body-text"> Total Amt BFT :</td>
//                                             <td className="table-body-text text-end">
//                                                 {" "}
//                                                 {PackingChallanData?.totalAmount}
//                                             </td>
//                                         </tr>
//                                         <tr className="table-body">
//                                             <td className="table-body-text"> Total GST :</td>
//                                             <td className="table-body-text text-end">
//                                                 {" "} {PackingChallanData?.gst_amount}
//                                             </td>
//                                         </tr>
//                                         <tr className="table-body">
//                                             <td className="table-body-text"> Net Amount :</td>
//                                             <td className="table-body-text text-end">
//                                                 {" "} {PackingChallanData?.net_amount}
//                                             </td>
//                                         </tr>
//                                     </tbody>
//                                 </table>
//                             </div>
//                         </div>
//                     </div>
//                     <div
//                         className="Print-Footer row g-0"
//                         style={{ border: "1px solid #000", borderTop: "0px solid #000" }}
//                     >
//                         <div className="col-7 py-4"></div>
//                         <div className="col-5 pe-4 text-end">
//                             <div
//                                 className="pt-2"
//                                 style={{
//                                     fontFamily: "Poppins",
//                                     fontSize: 13,
//                                     color: "#000",
//                                     fontWeight: 500,
//                                 }}
//                             >
//                                 For{" "}
//                                 <span
//                                     style={{
//                                         fontFamily: "Poppins",
//                                         fontSize: 14,
//                                         color: "#000",
//                                         fontWeight: 600,
//                                     }}
//                                 >
//                                     {UserDetail?.result?.user?.company_name}
//                                 </span>
//                             </div>
//                             <div
//                                 className="pt-4"
//                                 style={{
//                                     fontFamily: "Poppins",
//                                     fontSize: 13,
//                                     color: "#000",
//                                     fontWeight: 500,
//                                 }}
//                             >
//                                 (Authorised Signatory)
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <Backdrop
//                 sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
//                 open={Loader}
//             >
//                 <CircularProgress color="inherit" />
//             </Backdrop>

//             <div className="main-box">
//                 <ThemeProvider theme={theme}>
//                     <div className="box-head transaction">
//                         <Stack className="heading" alignItems="center" direction="row">
//                             <IconButton
//                                 color="primary"
//                                 onClick={() => {
//                                     navigate(`/CompanyDashboard`);
//                                 }}
//                             >
//                                 <ArrowBackIosIcon sx={{ fontSize: "20px" }} />
//                             </IconButton>
//                             <Typography variant="h4">Packing challan</Typography>
//                             {totalRecords ? (
//                                 <StyledTypography variant="caption">{totalRecords}</StyledTypography>
//                             ) : (
//                                 <></>
//                             )}
//                         </Stack>
//                         <Stack alignItems="center" direction="row">
//                             {PermitData.result?.IsSearch === true ? (
//                                 <TextField
//                                     id="Search"
//                                     placeholder="Search"
//                                     value={searchQuery}
//                                     onChange={handleSearchChange}

//                                 />
//                             ) : null}
//                         </Stack>
//                         {PermitData.result?.IsSearch === true ? (
//                             <Stack alignItems="center" direction="row">
//                                 <FormControlLabel
//                                     control={
//                                         <Checkbox
//                                             checked={FilterWithDate}
//                                             onChange={(event) => {
//                                                 setFilterWithDate(event.target.checked);
//                                                 setPage(1);
//                                                 if (!event.target.checked) {
//                                                     setFromDate("");
//                                                     setToDate("");
//                                                 }
//                                             }}
//                                             sx={{ py: 0 }}
//                                         />
//                                     }
//                                     label="Filter Date"
//                                 />
//                                 <ArrowDropDownIcon onClick={handleClick}
//                                     sx={{
//                                         display: "none", "@media (max-width: 1150px)": {
//                                             display: FilterWithDate ? "inline" : "none"
//                                         }
//                                     }} />
//                                 <ThemeProvider theme={form}>
//                                     <LocalizationProvider dateAdapter={AdapterDayjs} locale={enGB}>
//                                         <Popover
//                                             id={"simple-popover"}
//                                             open={filterDates}
//                                             anchorEl={anchorEl}
//                                             onClose={handleClose}
//                                             anchorOrigin={{
//                                                 vertical: "top",
//                                                 horizontal: "right",
//                                             }}
//                                             sx={{
//                                                 "@media (min-width: 1150px)": {
//                                                     display: "none"
//                                                 },
//                                             }}
//                                         >
//                                             <Box sx={{
//                                                 display: FilterWithDate ? "flex" : "none", p: 1, gap: 1
//                                             }}>
//                                                 <DatePicker
//                                                     format="DD/MM/YYYY"
//                                                     disabled={!FilterWithDate}
//                                                     slotProps={{ textField: { placeholder: "Start Date" } }}
//                                                     value={FromDate ? dayjs(FromDate) : null}
//                                                     onChange={(newValue) =>
//                                                         handleFromDate(
//                                                             newValue?.format("YYYY-MM-DD")
//                                                         )
//                                                     }
//                                                     renderInput={(params) => <TextField {...params} />}
//                                                 />
//                                                 <DatePicker
//                                                     format="DD/MM/YYYY"
//                                                     disabled={!FilterWithDate}
//                                                     slotProps={{ textField: { placeholder: "End Date" } }}
//                                                     value={ToDate ? dayjs(ToDate) : null}
//                                                     onChange={(newValue) =>
//                                                         handleToDate(
//                                                             newValue?.format("YYYY-MM-DD")
//                                                         )
//                                                     }
//                                                     renderInput={(params) => <TextField {...params} />}
//                                                 />
//                                             </Box>
//                                         </Popover>
//                                         <Box sx={{
//                                             display: FilterWithDate ? "flex" : "none",
//                                             "@media (max-width: 1150px)": {
//                                                 display: "none"
//                                             },
//                                             gap: 1
//                                         }}>
//                                             <DatePicker
//                                                 format="DD/MM/YYYY"
//                                                 disabled={!FilterWithDate}
//                                                 slotProps={{ textField: { placeholder: "Start Date" } }}
//                                                 value={FromDate ? dayjs(FromDate) : null}
//                                                 onChange={(newValue) =>
//                                                     handleFromDate(
//                                                         newValue?.format("YYYY-MM-DD")
//                                                     )
//                                                 }
//                                                 renderInput={(params) => <TextField {...params} />}
//                                             />
//                                             <DatePicker
//                                                 format="DD/MM/YYYY"
//                                                 disabled={!FilterWithDate}
//                                                 slotProps={{ textField: { placeholder: "End Date" } }}
//                                                 value={ToDate ? dayjs(ToDate) : null}
//                                                 onChange={(newValue) =>
//                                                     handleToDate(
//                                                         newValue?.format("YYYY-MM-DD")
//                                                     )
//                                                 }
//                                                 renderInput={(params) => <TextField {...params} />}
//                                             />
//                                         </Box>
//                                     </LocalizationProvider>
//                                 </ThemeProvider>
//                             </Stack>
//                         ) : null}
//                         <Stack className="btns" alignItems="center" direction="row">
//                             {PermitData.result?.IsPrint === true ? (
//                                 <>
//                                     <Button variant="contained" startIcon={<SaveAltIcon />} onClick={handleDownloadCSV}>
//                                         CSV
//                                     </Button>
//                                 </>
//                             ) : (
//                                 <></>
//                             )}
//                             {PermitData.result?.IsSave === true ? (
//                                 <Button
//                                     onClick={() => {
//                                         return navigate("AddPackingChallan");
//                                     }}
//                                     variant="contained"
//                                 >
//                                     + New
//                                 </Button>
//                             ) : (
//                                 <></>
//                             )}
//                         </Stack>
//                     </div>
//                     <Backdrop
//                         sx={{ color: "#fff", zIndex: 9999 }}
//                         open={Loader}
//                     >
//                         <CircularProgress color="inherit" />
//                     </Backdrop>
//                     <DeleteDialog
//                         modalOpen={modalOpenDelete}
//                         handleModalClose={() => handleModalCloseDelete()}
//                         executeConfirmed={() => handleModalOpenPassword()}
//                     />
//                     <PasswordDialog
//                         modalOpen={modalOpenPassword}
//                         handleModalClose={() => handleModalClosePassword()}
//                         executeConfirmed={() => removeSaleBill()}
//                     />

//                     <div className="card-form-box transaction">
//                         {status == "loading" ? (
//                             <>
//                                 <div
//                                     style={{
//                                         height: "100%",
//                                         display: "grid",
//                                         placeContent: "center",
//                                     }}
//                                 >
//                                     <CircularProgress sx={{ ml: 1, mb: 1 }} />
//                                     <Typography variant="subtitle2">Loading...</Typography>
//                                 </div>
//                             </>
//                         ) : (
//                             <>
//                                 <Paper
//                                     sx={{
//                                         width: "100%", height: "100%", overflowY: "scroll",
//                                         "::-webkit-scrollbar": {
//                                             display: "none"
//                                         }
//                                     }}
//                                 >
//                                     <TableContainer component={Paper} sx={{ height: "100%" }}>
//                                         {status == "failed" || statusS == false ? (
//                                             <>
//                                                 <div className="d-flex justify-content-center">
//                                                     <img src={noData} />
//                                                 </div>
//                                             </>
//                                         ) : (
//                                             <>
//                                                 <Table
//                                                     stickyHeader
//                                                     sx={{ minWidth: 650 }}
//                                                     size="small"
//                                                     aria-label="a dense table"
//                                                 >
//                                                     <TableHead>
//                                                         <TableRow>
//                                                             <TableCell sx={{ fontWeight: 600 }}>Challan No.</TableCell>
//                                                             <TableCell sx={{ fontWeight: 600 }}>Date</TableCell>
//                                                             <TableCell sx={{ fontWeight: 600 }}>Bill No.</TableCell>
//                                                             <TableCell sx={{ fontWeight: 600 }}>Bill Date</TableCell>
//                                                             <TableCell sx={{ fontWeight: 600 }}>Party</TableCell>
//                                                             <TableCell sx={{ fontWeight: 600 }}>Transport</TableCell>
//                                                             <TableCell sx={{ fontWeight: 600 }}>Qty</TableCell>
//                                                             <TableCell sx={{ fontWeight: 600 }}>Taxable Amt</TableCell>
//                                                             <TableCell sx={{ fontWeight: 600 }}>Total Amt</TableCell>
//                                                             <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
//                                                             <TableCell sx={{ fontWeight: 600 }}align="center">Action</TableCell>
//                                                         </TableRow>
//                                                     </TableHead>
//                                                     <TableBody>
//                                                         {paginatedData?.map((row, index) => {
//                                                             return (
//                                                                 <TableRow hover key={index} sx={{ py: 0.5 }}>
//                                                                     <TableCell sx={{ py: 0.5 }}>{row.purchase_no}</TableCell>
//                                                                     <TableCell sx={{ py: 0.5 }}>{DateToShow(row.createdAt)}</TableCell>
//                                                                     <TableCell sx={{ py: 0.5 }}>{row.bill_no}</TableCell>
//                                                                     <TableCell sx={{ py: 0.5 }}>{DateToShow(row.bill_date)}</TableCell>
//                                                                     <TableCell sx={{ py: 0.5 }}>{cmpdetail?.company_name}</TableCell>
//                                                                     <TableCell sx={{ py: 0.5 }}>{row.transport}</TableCell>
//                                                                     <TableCell sx={{ py: 0.5 }}>{row.total_quantity}</TableCell>
//                                                                     <TableCell sx={{ py: 0.5 }}>{row.totalAmount}</TableCell>
//                                                                     <TableCell sx={{ py: 0.5 }}>{row.net_amount}</TableCell>
//                                                                     <TableCell sx={{ py: 0.5 }}>
//                                                                         {!row?.is_downloaded ? (
//                                                                             <Chip
//                                                                                 label="Pending"
//                                                                                 size="small"
//                                                                                 sx={{
//                                                                                     bgcolor: "#F55050",
//                                                                                     color: "#fff",
//                                                                                     fontSize: "10px",
//                                                                                 }}
//                                                                             />
//                                                                         ) : (
//                                                                             <Chip
//                                                                                 label="Downloaded"
//                                                                                 size="small"
//                                                                                 sx={{
//                                                                                     bgcolor: "#2EB086",
//                                                                                     color: "#fff",
//                                                                                     fontSize: "10px",
//                                                                                 }}
//                                                                             />
//                                                                         )}
//                                                                     </TableCell>
//                                                                     <TableCell align="center" sx={{ py: 0.5 }}>
//                                                                         <Box
//                                                                             display="flex"
//                                                                             justifyContent="space-evenly"
//                                                                         >
//                                                                             {PermitData.result?.IsPrint ===
//                                                                                 true ? (
//                                                                                 <>
//                                                                                     <IconButton
//                                                                                         color="primary"
//                                                                                         aria-label="print"
//                                                                                         onClick={() => {
//                                                                                             openPrint(row.id);
//                                                                                         }}
//                                                                                         sx={{ padding: 0, margin: 0 }}
//                                                                                     >
//                                                                                         <LocalPrintshopIcon
//                                                                                             sx={{ fontSize: "20px" }}
//                                                                                         />
//                                                                                     </IconButton>
//                                                                                 </>
//                                                                             ) : (
//                                                                                 <IconButton
//                                                                                     disabled
//                                                                                     aria-label="print"
//                                                                                     sx={{ padding: 0, margin: 0 }}
//                                                                                 >
//                                                                                     <LocalPrintshopIcon
//                                                                                         sx={{ fontSize: "20px" }}
//                                                                                     />
//                                                                                 </IconButton>
//                                                                             )}
//                                                                             {PermitData.result?.IsUpdate ===
//                                                                                 true ? (
//                                                                                 <>
//                                                                                     <IconButton
//                                                                                         color="primary"
//                                                                                         aria-label="Edit"
//                                                                                         onClick={() => {
//                                                                                             navigate(
//                                                                                                 `EditPackingChallan/${row.id}`
//                                                                                             );
//                                                                                         }}
//                                                                                         sx={{ padding: 0, margin: 0 }}
//                                                                                     >
//                                                                                         <ModeEditOutlinedIcon
//                                                                                             sx={{ fontSize: "20px" }}
//                                                                                         />
//                                                                                     </IconButton>
//                                                                                 </>
//                                                                             ) : (
//                                                                                 <IconButton
//                                                                                     disabled
//                                                                                     aria-label="edit"
//                                                                                     sx={{ padding: 0, margin: 0 }}
//                                                                                 >
//                                                                                     <ModeEditOutlinedIcon
//                                                                                         sx={{ fontSize: "20px" }}
//                                                                                     />
//                                                                                 </IconButton>
//                                                                             )}
//                                                                         </Box>
//                                                                     </TableCell>
//                                                                 </TableRow>
//                                                             );
//                                                         })}
//                                                     </TableBody>
//                                                 </Table>
//                                             </>
//                                         )}
//                                     </TableContainer>
//                                 </Paper>
//                             </>
//                         )}
//                     </div>
//                     <div className="pagination-box d-flex justify-content-end align-items-center">
//                         <RowPages
//                             rowsPerPage={rowsPerPage}
//                             onRowsPerPageChange={(value) => handleChangeRowsPerPage(value)}
//                             All={totalRecords}
//                         />
//                         <Pagination
//                             count={totalPages}
//                             page={page}
//                             siblingCount={isMobile ? 0 : 1}
//                             boundaryCount={isMobile ? 0 : 1}
//                             onChange={handlePageChange}
//                             color="primary"
//                             size="small"
//                         />
//                     </div>
//                 </ThemeProvider>
//             </div>
//             <Toaster position="top-center" reverseOrder={false} />
//         </>
//     );
// };

// // ---------------------------------------------------------------------
// // CHANGED: no longer dispatches fetchDataPK on mount here — the child
// // component now owns page/search/date state and re-fetches whenever
// // those change (see the debounced useEffect above). This wrapper just
// // reads the redux result and derives totalRecords / totalPages for it.
// // ---------------------------------------------------------------------
// export default function TableData() {
//     const { result, status } = useSelector((state) => state.PackingChallanData);
//     // Adjust these two field names (totalCount / limit) to match whatever
//     // your backend actually returns in its paginated response envelope.
//     const totalRecords = result?.totalCount ?? 0;
//     const limit = result?.limit ?? 30;
//     const totalPages = Math.max(1, Math.ceil(totalRecords / limit));

//     return (
//         <>
//             <DataTableWithPagination
//                 data={result?.data}
//                 status={status}
//                 statusS={result?.status}
//                 totalRecords={totalRecords}
//                 totalPages={totalPages}
//             />
//         </>
//     );
// }